// Centralized translations for Mus.Link
// Languages: EN (default), RU, ES

export const translations = {
  // ==================== COMMON ====================
  common: {
    en: {
      appName: "Mus.Link",
      loading: "Loading...",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      create: "Create",
      back: "Back",
      next: "Next",
      submit: "Submit",
      confirm: "Confirm",
      close: "Close",
      search: "Search",
      filter: "Filter",
      all: "All",
      none: "None",
      yes: "Yes",
      no: "No",
      or: "or",
      and: "and",
      copy: "Copy",
      copied: "Copied!",
      share: "Share",
      download: "Download",
      upload: "Upload",
      preview: "Preview",
      settings: "Settings",
      help: "Help",
      logout: "Logout",
      login: "Login",
      register: "Register",
      email: "Email",
      password: "Password",
      username: "Username",
      name: "Name",
      title: "Title",
      description: "Description",
      url: "URL",
      link: "Link",
      links: "Links",
      page: "Page",
      pages: "Pages",
      user: "User",
      users: "Users",
      admin: "Admin",
      dashboard: "Dashboard",
      analytics: "Analytics",
      views: "Views",
      clicks: "Clicks",
      today: "Today",
      week: "Week",
      month: "Month",
      year: "Year",
      total: "Total",
      active: "Active",
      inactive: "Inactive",
      enabled: "Enabled",
      disabled: "Disabled",
      enable: "Enable",
      disable: "Disable",
      free: "Free",
      pro: "Pro",
      upgrade: "Upgrade",
      plan: "Plan",
      artist: "Artist",
      release: "Release",
      cover: "Cover",
      platform: "Platform",
      platforms: "Platforms",
      error: "Error",
      success: "Success",
      warning: "Warning",
      info: "Info",
      selected: "selected",
      current: "Current",
      listen: "Listen",
    },
    ru: {
      appName: "Mus.Link",
      loading: "Загрузка...",
      save: "Сохранить",
      cancel: "Отмена",
      delete: "Удалить",
      edit: "Редактировать",
      create: "Создать",
      back: "Назад",
      next: "Далее",
      submit: "Отправить",
      confirm: "Подтвердить",
      close: "Закрыть",
      search: "Поиск",
      filter: "Фильтр",
      all: "Все",
      none: "Нет",
      yes: "Да",
      no: "Нет",
      or: "или",
      and: "и",
      copy: "Копировать",
      copied: "Скопировано!",
      share: "Поделиться",
      download: "Скачать",
      upload: "Загрузить",
      preview: "Предпросмотр",
      settings: "Настройки",
      help: "Помощь",
      logout: "Выйти",
      login: "Войти",
      register: "Регистрация",
      email: "E-Mail",
      password: "Пароль",
      username: "Имя пользователя",
      name: "Имя",
      title: "Название",
      description: "Описание",
      url: "URL",
      link: "Ссылка",
      links: "Ссылки",
      page: "Страница",
      pages: "Страницы",
      user: "Пользователь",
      users: "Пользователи",
      admin: "Админ",
      dashboard: "Панель",
      analytics: "Аналитика",
      views: "Просмотры",
      clicks: "Клики",
      today: "Сегодня",
      week: "Неделя",
      month: "Месяц",
      year: "Год",
      total: "Всего",
      active: "Активно",
      inactive: "Неактивно",
      enabled: "Включено",
      disabled: "Выключено",
      enable: "Включить",
      disable: "Выключить",
      free: "Бесплатно",
      pro: "Pro",
      upgrade: "Улучшить",
      plan: "План",
      artist: "Исполнитель",
      release: "Релиз",
      cover: "Обложка",
      platform: "Платформа",
      platforms: "Платформы",
      error: "Ошибка",
      success: "Успешно",
      warning: "Предупреждение",
      info: "Информация",
      selected: "выбран",
      current: "Текущий",
      listen: "Слушать",
    },
    es: {
      appName: "Mus.Link",
      loading: "Cargando...",
      save: "Guardar",
      cancel: "Cancelar",
      delete: "Eliminar",
      edit: "Editar",
      create: "Crear",
      back: "Atrás",
      next: "Siguiente",
      submit: "Enviar",
      confirm: "Confirmar",
      close: "Cerrar",
      search: "Buscar",
      filter: "Filtrar",
      all: "Todo",
      none: "Ninguno",
      yes: "Sí",
      no: "No",
      or: "o",
      and: "y",
      copy: "Copiar",
      copied: "¡Copiado!",
      share: "Compartir",
      download: "Descargar",
      upload: "Subir",
      preview: "Vista previa",
      settings: "Ajustes",
      help: "Ayuda",
      logout: "Cerrar sesión",
      login: "Iniciar sesión",
      register: "Registrarse",
      email: "Correo electrónico",
      password: "Contraseña",
      username: "Nombre de usuario",
      name: "Nombre",
      title: "Título",
      description: "Descripción",
      url: "URL",
      link: "Enlace",
      links: "Enlaces",
      page: "Página",
      pages: "Páginas",
      user: "Usuario",
      users: "Usuarios",
      admin: "Admin",
      dashboard: "Panel",
      analytics: "Analíticas",
      views: "Vistas",
      clicks: "Clics",
      today: "Hoy",
      week: "Semana",
      month: "Mes",
      year: "Año",
      total: "Total",
      active: "Activo",
      inactive: "Inactivo",
      enabled: "Activado",
      disabled: "Desactivado",
      enable: "Activar",
      disable: "Desactivar",
      free: "Gratis",
      pro: "Pro",
      upgrade: "Mejorar",
      plan: "Plan",
      artist: "Artista",
      release: "Lanzamiento",
      cover: "Portada",
      platform: "Plataforma",
      platforms: "Plataformas",
      error: "Error",
      success: "Éxito",
      warning: "Advertencia",
      info: "Información",
      selected: "seleccionado",
      current: "Actual",
      listen: "Escuchar",
    },
  },

  // ==================== NAVIGATION ====================
  nav: {
    en: {
      home: "Home",
      login: "Login",
      register: "Get Started",
      panel: "Panel",
      create: "Create",
      multilinks: "My Links",
      analytics: "Analytics",
      domains: "Domains",
      settings: "Settings",
      admin: "Admin",
      support: "Support",
      faq: "FAQ",
      pricing: "Pricing",
      logout: "Logout",
    },
    ru: {
      home: "Главная",
      login: "Войти",
      register: "Начать",
      panel: "Панель",
      create: "Создать",
      multilinks: "Мои ссылки",
      analytics: "Аналитика",
      domains: "Домены",
      settings: "Настройки",
      admin: "Админ",
      support: "Поддержка",
      faq: "FAQ",
      pricing: "Тарифы",
      logout: "Выйти",
    },
    es: {
      home: "Inicio",
      login: "Iniciar sesión",
      register: "Comenzar",
      panel: "Panel",
      create: "Crear",
      multilinks: "Mis enlaces",
      analytics: "Analíticas",
      domains: "Dominios",
      settings: "Ajustes",
      admin: "Admin",
      support: "Soporte",
      faq: "FAQ",
      pricing: "Precios",
      logout: "Cerrar sesión",
    },
  },

  // ==================== LANDING PAGE ====================
  landing: {
    en: {
      heroTitle1: "CREATE",
      heroTitle2: "SMART LINK",
      heroTitle3: "FOR YOUR",
      heroTitle4: "MUSIC",
      heroSubtitle: "Stylish pages for your releases. One link — all platforms.",
      createPage: "Create Page",
      demo: "Demo",
      featuresTitle: "Why Mus.Link?",
      feature1Title: "One Link",
      feature1Desc: "All streaming platforms in one smart link",
      feature2Title: "Analytics",
      feature2Desc: "Track clicks and views in real-time",
      feature3Title: "Fast Setup",
      feature3Desc: "Create your page in just a few clicks",
      ctaTitle: "Ready to start?",
      ctaSubtitle: "Create your smart link page in minutes",
      ctaButton: "Get Started Free",
      footer: "All rights reserved.",
    },
    ru: {
      heroTitle1: "СОЗДАЙ",
      heroTitle2: "МУЛЬТИССЫЛКУ",
      heroTitle3: "ДЛЯ СВОЕЙ",
      heroTitle4: "МУЗЫКИ",
      heroSubtitle: "Стильные страницы для ваших релизов. Одна ссылка — все платформы.",
      createPage: "Создать страницу",
      demo: "Демо",
      featuresTitle: "Почему Mus.Link?",
      feature1Title: "Одна ссылка",
      feature1Desc: "Все стриминговые платформы в одной смарт-ссылке",
      feature2Title: "Аналитика",
      feature2Desc: "Отслеживайте клики и просмотры в реальном времени",
      feature3Title: "Быстрая настройка",
      feature3Desc: "Создайте страницу всего за несколько кликов",
      ctaTitle: "Готовы начать?",
      ctaSubtitle: "Создайте свою смарт-ссылку за минуту",
      ctaButton: "Начать бесплатно",
      footer: "Все права защищены.",
    },
    es: {
      heroTitle1: "CREA",
      heroTitle2: "ENLACE INTELIGENTE",
      heroTitle3: "PARA TU",
      heroTitle4: "MÚSICA",
      heroSubtitle: "Páginas elegantes para tus lanzamientos. Un enlace — todas las plataformas.",
      createPage: "Crear página",
      demo: "Demo",
      featuresTitle: "¿Por qué Mus.Link?",
      feature1Title: "Un enlace",
      feature1Desc: "Todas las plataformas de streaming en un enlace inteligente",
      feature2Title: "Analíticas",
      feature2Desc: "Rastrea clics y vistas en tiempo real",
      feature3Title: "Configuración rápida",
      feature3Desc: "Crea tu página en solo unos clics",
      ctaTitle: "¿Listo para empezar?",
      ctaSubtitle: "Crea tu enlace inteligente en minutos",
      ctaButton: "Comenzar gratis",
      footer: "Todos los derechos reservados.",
    },
  },

  // ==================== AUTH ====================
  auth: {
    en: {
      loginTitle: "Sign in",
      loginSubtitle: "Sign in to manage your account",
      registerTitle: "Create account",
      registerSubtitle: "Create your account to manage smart links",
      emailPlaceholder: "your@email.com",
      passwordPlaceholder: "Enter password",
      usernamePlaceholder: "Your username",
      confirmPassword: "Confirm password",
      forgotPassword: "Forgot password?",
      rememberMe: "Remember me",
      loginButton: "Sign In",
      registerButton: "Create Account",
      noAccount: "Don't have an account?",
      hasAccount: "Already have an account?",
      signUp: "Sign up",
      signIn: "Sign in",
      orContinueWith: "Or continue with",
      termsAgree: "By signing up, you agree to our",
      terms: "Terms of Service",
      privacy: "Privacy Policy",
      invalidCredentials: "Invalid email or password",
      emailRequired: "Email is required",
      passwordRequired: "Password is required",
      usernameRequired: "Username is required",
      passwordMinLength: "Password must be at least 6 characters",
      emailInvalid: "Please enter a valid email",
      registrationSuccess: "Registration completed. Please sign in.",
      forgotPasswordTitle: "Reset password",
      forgotPasswordSubtitle: "Enter your email to receive reset instructions",
      sendResetLink: "Send reset link",
      backToLogin: "Back to login",
      resetEmailSent: "Password reset email sent. Please check your inbox.",
      resetPasswordTitle: "Create new password",
      resetPasswordSubtitle: "Enter your new password",
      newPassword: "New password",
      invalidResetLink: "Invalid password reset link",
      passwordMismatch: "Passwords do not match",
      passwordChangedTitle: "Password updated",
      passwordChangedDesc: "Your password has been updated. Please sign in to your account.",
      requestNewLink: "Request a new link",
      goToLogin: "Go to sign in",
      minPasswordHint: "Minimum 6 characters",
      confirmNewPassword: "Confirm password",
      saving: "Saving...",
      securityTitle: "Security",
      securityDesc: "Create a strong password to protect your account.",
      resetButton: "Reset password",
      passwordResetSuccess: "Password reset successfully. Please sign in.",
      // Right side panel
      sideTitle: "Manage all music links in one dashboard",
      sideSubtitle: "Releases, analytics, and public pages in one account.",
    },
    ru: {
      loginTitle: "Вход в аккаунт",
      loginSubtitle: "Войдите, чтобы управлять своим аккаунтом",
      registerTitle: "Создать аккаунт",
      registerSubtitle: "Создайте аккаунт для управления смарт-ссылками",
      emailPlaceholder: "artist@mail.com",
      passwordPlaceholder: "Введите пароль",
      usernamePlaceholder: "Ваше имя пользователя",
      confirmPassword: "Подтвердите пароль",
      forgotPassword: "Забыли пароль?",
      rememberMe: "Запомнить меня",
      loginButton: "Войти",
      registerButton: "Создать аккаунт",
      noAccount: "Нет аккаунта?",
      hasAccount: "Уже есть аккаунт?",
      signUp: "Зарегистрироваться",
      signIn: "Войти",
      orContinueWith: "Или продолжить с",
      termsAgree: "Регистрируясь, вы соглашаетесь с",
      terms: "Условия использования",
      privacy: "Политика конфиденциальности",
      invalidCredentials: "Неверный логин или пароль",
      emailRequired: "Email обязателен",
      passwordRequired: "Пароль обязателен",
      usernameRequired: "Имя пользователя обязательно",
      passwordMinLength: "Пароль должен быть минимум 6 символов",
      emailInvalid: "Введите корректный email",
      registrationSuccess: "Регистрация завершена. Войдите в аккаунт.",
      forgotPasswordTitle: "Сброс пароля",
      forgotPasswordSubtitle: "Введите email для получения инструкций",
      sendResetLink: "Отправить ссылку",
      backToLogin: "Вернуться к входу",
      resetEmailSent: "Письмо для сброса пароля отправлено. Проверьте почту.",
      resetPasswordTitle: "Создать новый пароль",
      resetPasswordSubtitle: "Введите новый пароль",
      newPassword: "Новый пароль",
      invalidResetLink: "Недействительная ссылка для сброса пароля",
      passwordMismatch: "Пароли не совпадают",
      passwordChangedTitle: "Пароль изменён",
      passwordChangedDesc: "Пароль успешно изменён. Войдите в свой аккаунт.",
      requestNewLink: "Запросить новую ссылку",
      goToLogin: "Перейти к входу",
      minPasswordHint: "Минимум 6 символов",
      confirmNewPassword: "Подтвердите пароль",
      saving: "Сохранение...",
      securityTitle: "Безопасность",
      securityDesc: "Создайте надёжный пароль для защиты аккаунта.",
      resetButton: "Сбросить пароль",
      passwordResetSuccess: "Пароль успешно сброшен. Войдите в аккаунт.",
      // Right side panel
      sideTitle: "Все музыкальные ссылки в одном кабинете",
      sideSubtitle: "Релизы, аналитика и публичные страницы в одном аккаунте.",
    },
    es: {
      loginTitle: "Inicio de sesión",
      loginSubtitle: "Inicia sesión para gestionar tu cuenta",
      registerTitle: "Crear cuenta",
      registerSubtitle: "Crea tu cuenta para gestionar enlaces inteligentes",
      emailPlaceholder: "tu@email.com",
      passwordPlaceholder: "Ingresa contraseña",
      usernamePlaceholder: "Tu nombre de usuario",
      confirmPassword: "Confirmar contraseña",
      forgotPassword: "¿Olvidaste tu contraseña?",
      rememberMe: "Recuérdame",
      loginButton: "Iniciar sesión",
      registerButton: "Crear cuenta",
      noAccount: "¿No tienes cuenta?",
      hasAccount: "¿Ya tienes cuenta?",
      signUp: "Regístrate",
      signIn: "Inicia sesión",
      orContinueWith: "O continuar con",
      termsAgree: "Al registrarte, aceptas nuestros",
      terms: "Términos de servicio",
      privacy: "Política de privacidad",
      invalidCredentials: "Correo o contraseña incorrectos",
      emailRequired: "El correo es obligatorio",
      passwordRequired: "La contraseña es obligatoria",
      usernameRequired: "El nombre de usuario es obligatorio",
      passwordMinLength: "La contraseña debe tener al menos 6 caracteres",
      emailInvalid: "Ingresa un correo válido",
      registrationSuccess: "Registro completado. Por favor, inicia sesión.",
      forgotPasswordTitle: "Restablecer contraseña",
      forgotPasswordSubtitle: "Ingresa tu correo para recibir instrucciones",
      sendResetLink: "Enviar enlace",
      backToLogin: "Volver al inicio de sesión",
      resetEmailSent: "Correo de restablecimiento enviado. Revisa tu bandeja.",
      resetPasswordTitle: "Crear nueva contraseña",
      resetPasswordSubtitle: "Ingresa tu nueva contraseña",
      newPassword: "Nueva contraseña",
      invalidResetLink: "Enlace de restablecimiento inválido",
      passwordMismatch: "Las contraseñas no coinciden",
      passwordChangedTitle: "Contraseña actualizada",
      passwordChangedDesc: "Tu contraseña ha sido actualizada. Inicia sesión en tu cuenta.",
      requestNewLink: "Solicitar un nuevo enlace",
      goToLogin: "Ir al inicio de sesión",
      minPasswordHint: "Mínimo 6 caracteres",
      confirmNewPassword: "Confirmar contraseña",
      saving: "Guardando...",
      securityTitle: "Seguridad",
      securityDesc: "Crea una contraseña segura para proteger tu cuenta.",
      resetButton: "Restablecer contraseña",
      passwordResetSuccess: "Contraseña restablecida. Por favor, inicia sesión.",
      // Right side panel
      sideTitle: "Gestiona tus enlaces desde un panel",
      sideSubtitle: "Lanzamientos, analíticas y páginas públicas en una cuenta.",
    },
  },

  // ==================== DASHBOARD ====================
  dashboard: {
    en: {
      title: "My Pages",
      subtitle: "Manage your smart link pages",
      createNew: "Create New Page",
      noPages: "No pages yet",
      noPagesDesc: "Create your first smart link page",
      totalViews: "Total Views",
      totalClicks: "Total Clicks",
      activePages: "Active Pages",
      recentActivity: "Recent Activity",
      quickStats: "Quick Stats",
      viewAll: "View All",
      editPage: "Edit",
      viewPage: "View",
      deletePage: "Delete",
      duplicatePage: "Duplicate",
      pagination: "Pagination",
      confirmDelete: "Are you sure you want to delete this page?",
      pageDeleted: "Page deleted successfully",
      pageDuplicated: "Page duplicated successfully",
      linksCount: "links",
      lastUpdated: "Last updated",
      published: "Published",
      draft: "Draft",
    },
    ru: {
      title: "Мультиссылки",
      subtitle: "Управляйте своими смарт-ссылками",
      createNew: "Создать новую страницу",
      noPages: "Пока нет страниц",
      noPagesDesc: "Создайте свою первую смарт-ссылку",
      totalViews: "Всего просмотров",
      totalClicks: "Всего кликов",
      activePages: "Активных страниц",
      recentActivity: "Последняя активность",
      quickStats: "Статистика",
      viewAll: "Смотреть все",
      editPage: "Редактировать",
      viewPage: "Просмотр",
      deletePage: "Удалить",
      duplicatePage: "Дублировать",
      pagination: "Пагинация",
      confirmDelete: "Вы уверены, что хотите удалить эту страницу?",
      pageDeleted: "Страница успешно удалена",
      pageDuplicated: "Страница успешно дублирована",
      linksCount: "ссылок",
      lastUpdated: "Обновлено",
      published: "Опубликовано",
      draft: "Черновик",
    },
    es: {
      title: "Mis páginas",
      subtitle: "Administra tus páginas de enlaces inteligentes",
      createNew: "Crear nueva página",
      noPages: "Sin páginas aún",
      noPagesDesc: "Crea tu primera página de enlace inteligente",
      totalViews: "Vistas totales",
      totalClicks: "Clics totales",
      activePages: "Páginas activas",
      recentActivity: "Actividad reciente",
      quickStats: "Estadísticas",
      viewAll: "Ver todo",
      editPage: "Editar",
      viewPage: "Ver",
      deletePage: "Eliminar",
      duplicatePage: "Duplicar",
      pagination: "Paginación",
      confirmDelete: "¿Estás seguro de que quieres eliminar esta página?",
      pageDeleted: "Página eliminada exitosamente",
      pageDuplicated: "Página duplicada exitosamente",
      linksCount: "enlaces",
      lastUpdated: "Actualizado",
      published: "Publicado",
      draft: "Borrador",
    },
  },

  // ==================== PAGE BUILDER ====================
  pageBuilder: {
    en: {
      title: "Page Builder",
      newPage: "New Page",
      editPage: "Edit Page",
      basicInfo: "Basic Info",
      artistName: "Artist Name",
      artistPlaceholder: "Enter artist name",
      artistLabel: "Artist",
      releaseLabel: "Release title",
      descriptionLabel: "Description",
      descriptionPlaceholder: "Description of your release...",
      releaseTitle: "Release Title",
      releasePlaceholder: "Enter release title",
      slug: "Page URL (slug)",
      slugPlaceholder: "your-unique-link",
      slugHint: "This will be your unique link",
      coverImage: "Cover Image",
      uploadCover: "Upload Cover",
      changeCover: "Change Cover",
      removeCover: "Remove Cover",
      autoFill: "Auto-fill",
      autoFillDesc: "Paste UPC code or link — data and platforms will be filled automatically",
      autoFillPlaceholder: "Paste UPC code or link from Apple/Spotify",
      autoFillButton: "Find",
      autoFillError: "Enter UPC code or Apple Music, Spotify, YouTube, Deezer, Tidal or SoundCloud link",
      searchingLinks: "Searching links on all platforms...",
      searchingUPC: "Searching by UPC code...",
      linksFound: "links found and added",
      allLinksAdded: "All available links already added",
      platformLinks: "Platform Links",
      addLink: "Add Link",
      selectPlatform: "Select platform",
      linkUrl: "Link URL",
      linkUrlPlaceholder: "https://...",
      customTitle: "Custom Title (optional)",
      appearance: "Appearance",
      backgroundColor: "Background Color",
      textColor: "Text Color",
      buttonStyle: "Button Style",
      previewTitle: "Preview",
      saveChanges: "Save Changes",
      saveDraft: "Save as Draft",
      publish: "Publish",
      saving: "Saving...",
      saved: "Saved!",
      pageSaved: "Page saved successfully",
      pagePublished: "Page published successfully",
      deleteLink: "Delete link",
      moveUp: "Move up",
      moveDown: "Move down",
      linkActive: "Link active",
      linkInactive: "Link inactive",
      qrCode: "QR Code",
      downloadQR: "Download QR",
      copyLink: "Copy Link",
      linkCopied: "Link copied to clipboard",
      openPage: "Open Page",
      unsavedChanges: "You have unsaved changes",
      discardChanges: "Discard changes?",
      editing: "Editing",
      viewPage: "View Page",
      tabSettings: "Settings",
      tabPreview: "Preview",
      autofill: "Auto-fill",
      autofillDesc: "Paste UPC code or link — data and platforms will be filled automatically",
      autofillPlaceholder: "Paste UPC code or link from Apple Music, Spotify, Yandex Music, YouTube, Deezer, Tidal",
      autofillHint: "Enter UPC code or Apple Music, Spotify, Yandex Music, YouTube, Deezer, Tidal or SoundCloud link",
      description: "Description (optional)",
      descPlaceholder: "Tell about the release...",
      coverHint: "Recommended: 1000x1000px, JPG or PNG",
      noLinks: "No links yet. Add your first link above.",
      qrDesc: "Scan to open the page",
      downloadPng: "Download PNG",
      enterUrlForQr: "Enter URL above to generate QR code",
      qrDisabled: "QR code disabled",
      pageCreated: "Page created",
      pageUpdated: "Page updated",
      autoSaved: "Saved",
      enterUrl: "Please enter URL",
      linkAdded: "Link added",
      linkDeleted: "Link deleted",
      linksAdded: "Links added",
      trackNotFound: "Track not found. Try another link.",
      upcNotFound: "Could not find release by UPC code. Check the code.",
      scanError: "Could not get links. Check the URL and try again.",
      allLinksAdded: "All available links are already added",
      linksWillAppear: "Links will appear here",
      pageDesign: "Page Design",
      darkTheme: "Dark",
      lightTheme: "Light",
      pageDesignHint: "Choose the theme for your public page",
      shareButtons: "Action Buttons",
      shareButtonsHint: "Show or hide the copy and share buttons on the public page",
      deletePage: "Delete Page",
      confirmDelete: "Are you sure you want to delete this page?",
      deleteModalCancel: "Cancel",
      deleteModalConfirm: "Delete",
      pageDeleted: "Page deleted successfully",
      // Sidebar navigation
      sidebarRelease: "Release",
      sidebarBasic: "Basic",
      sidebarBasicSettings: "Page settings",
      sidebarLinkAppearance: "Link appearance",
      sidebarAppearance: "Appearance",
      sidebarPromotion: "Promotion",
      mobileTabSettings: "Settings",
      mobileTabPreview: "Preview",
      sidebarBasicSettingsDesc: "Configure basic page display settings and add links to music services. Pasting a release link to iTunes will auto-fill basic fields.",
      addLinkBtn: "Add link",
      addPresave: "Add presave",
      sortByClicks: "Sort by clicks",
      artistSection: "Artist",
      changeBtn: "Change",
      displayArtistName: "Display artist name",
      releaseName: "Release",
      releaseDate: "Release date",
      previewPage: "Preview page",
      pasteLinkPlaceholder: "Just paste your link here",
      editLinkUrl: "Edit link",
      saveLink: "Save",
      deletePageConfirm: "Are you sure you want to delete this page? This action cannot be undone.",
    },
    ru: {
      title: "Конструктор страницы",
      newPage: "Новая страница",
      editPage: "Редактирование страницы",
      basicInfo: "Основная информация",
      artistName: "Имя исполнителя",
      artistPlaceholder: "Введите имя исполнителя",
      artistLabel: "Артист",
      releaseLabel: "Название релиза",
      descriptionLabel: "Описание",
      descriptionPlaceholder: "Описание вашего релиза...",
      releaseTitle: "Название релиза",
      releasePlaceholder: "Введите название релиза",
      slug: "URL страницы (slug)",
      slugPlaceholder: "ваша-уникальная-ссылка",
      slugHint: "Это будет ваша уникальная ссылка",
      coverImage: "Обложка",
      uploadCover: "Загрузить обложку",
      changeCover: "Изменить обложку",
      removeCover: "Удалить обложку",
      autoFill: "Автозаполнение",
      autoFillDesc: "Вставьте UPC код или ссылку — данные и платформы заполнятся автоматически",
      autoFillPlaceholder: "Вставьте UPC код или ссылку из Apple/Spotify",
      autoFillButton: "Найти",
      autoFillError: "Введите UPC код или ссылку Apple Music, Spotify, YouTube, Deezer, Tidal или SoundCloud",
      searchingLinks: "Поиск ссылок на всех платформах...",
      searchingUPC: "Поиск по UPC коду...",
      linksFound: "ссылок найдено и добавлено",
      allLinksAdded: "Все доступные ссылки уже добавлены",
      platformLinks: "Ссылки на платформы",
      addLink: "Добавить ссылку",
      selectPlatform: "Выберите платформу",
      linkUrl: "Уникальная ссылка",
      linkUrlPlaceholder: "https://...",
      customTitle: "Своё название (опционально)",
      appearance: "Внешний вид",
      backgroundColor: "Цвет фона",
      textColor: "Цвет текста",
      buttonStyle: "Стиль кнопок",
      previewTitle: "Предпросмотр",
      saveChanges: "Сохранить изменения",
      saveDraft: "Сохранить черновик",
      publish: "Опубликовать",
      saving: "Сохранение...",
      saved: "Сохранено!",
      pageSaved: "Страница успешно сохранена",
      pagePublished: "Страница успешно опубликована",
      deleteLink: "Удалить ссылку",
      moveUp: "Переместить вверх",
      moveDown: "Переместить вниз",
      linkActive: "Ссылка активна",
      linkInactive: "Ссылка неактивна",
      qrCode: "QR-код",
      downloadQR: "Скачать QR",
      copyLink: "Копировать ссылку",
      linkCopied: "Ссылка скопирована",
      openPage: "Открыть страницу",
      unsavedChanges: "У вас есть несохранённые изменения",
      discardChanges: "Отменить изменения?",
      editing: "Редактирование",
      viewPage: "Открыть страницу",
      tabSettings: "Настройки",
      tabPreview: "Превью",
      autofill: "Автозаполнение",
      autofillDesc: "Вставьте UPC код или ссылку — данные и платформы заполнятся автоматически",
      autofillPlaceholder: "Введите UPC код или ссылку Apple Music, Spotify, Яндекс Музыки, YouTube, Deezer, Tidal",
      autofillHint: "Введите UPC код или ссылку Apple Music, Spotify, Яндекс Музыки, YouTube, Deezer, Tidal или SoundCloud",
      description: "Описание (необязательно)",
      descPlaceholder: "Расскажите о релизе...",
      coverHint: "Рекомендуется: 1000x1000px, JPG или PNG",
      noLinks: "Ссылок пока нет. Добавьте первую ссылку выше.",
      qrDesc: "Сканируйте для открытия страницы",
      downloadPng: "Скачать PNG",
      enterUrlForQr: "Введите URL-адрес выше для генерации QR-кода",
      qrDisabled: "QR-код отключен",
      pageCreated: "Страница создана",
      pageUpdated: "Страница обновлена",
      autoSaved: "Сохранено",
      enterUrl: "Пожалуйста, введите URL",
      linkAdded: "Ссылка добавлена",
      linkDeleted: "Ссылка удалена",
      linksAdded: "Добавлено ссылок",
      trackNotFound: "Не удалось найти трек. Попробуйте другую ссылку.",
      upcNotFound: "Не удалось найти релиз по UPC коду. Проверьте код.",
      scanError: "Не удалось получить ссылки. Проверьте URL и попробуйте снова.",
      allLinksAdded: "Все доступные ссылки уже добавлены",
      linksWillAppear: "Здесь появятся ссылки",
      pageDesign: "Вид дизайна",
      darkTheme: "Тёмная",
      lightTheme: "Светлая",
      pageDesignHint: "Выберите тему для вашей публичной страницы",
      shareButtons: "Кнопки действий",
      shareButtonsHint: "Показывать или скрывать кнопки копирования и отправки на публичной странице",
      deletePage: "Удалить страницу",
      confirmDelete: "Вы уверены, что хотите удалить эту страницу?",
      deleteModalCancel: "Отмена",
      deleteModalConfirm: "Удалить",
      pageDeleted: "Страница успешно удалена",
      // Sidebar navigation
      sidebarRelease: "Релиз",
      sidebarBasic: "Основные",
      sidebarBasicSettings: "Настройки страницы",
      sidebarLinkAppearance: "Вид ссылки",
      sidebarAppearance: "Вид",
      sidebarPromotion: "Продвижение",
      mobileTabSettings: "Настройки",
      mobileTabPreview: "Превью",
      sidebarBasicSettingsDesc: "Позволяет настроить основные параметры отображения страницы релиза и добавить ссылки на музыкальные сервисы. Вставка ссылки на релиз в iTunes запускает автоматическое заполнение основных полей.",
      addLinkBtn: "Добавить ссылку",
      addPresave: "Добавить пресейв",
      sortByClicks: "Сортировать по кликам",
      artistSection: "Артист",
      changeBtn: "Изменить",
      displayArtistName: "Отображаемое имя артиста",
      releaseName: "Релиз",
      releaseDate: "Дата релиза",
      previewPage: "Превью страницы",
      pasteLinkPlaceholder: "Просто вставьте ссылку сюда",
      editLinkUrl: "Изменить ссылку",
      saveLink: "Сохранить",
      deletePageConfirm: "Вы уверены, что хотите удалить эту страницу? Это действие нельзя отменить.",
    },
    es: {
      title: "Constructor de página",
      newPage: "Nueva página",
      editPage: "Editar página",
      basicInfo: "Información básica",
      artistName: "Nombre del artista",
      artistPlaceholder: "Ingresa el nombre del artista",
      artistLabel: "Artista",
      releaseLabel: "Título del lanzamiento",
      descriptionLabel: "Descripción",
      descriptionPlaceholder: "Descripción de tu lanzamiento...",
      releaseTitle: "Título del lanzamiento",
      releasePlaceholder: "Ingresa el título del lanzamiento",
      slug: "URL de página (slug)",
      slugPlaceholder: "tu-enlace-unico",
      slugHint: "Este será tu enlace único",
      coverImage: "Imagen de portada",
      uploadCover: "Subir portada",
      changeCover: "Cambiar portada",
      removeCover: "Eliminar portada",
      autoFill: "Autocompletar",
      autoFillDesc: "Pega código UPC o enlace — los datos y plataformas se llenarán automáticamente",
      autoFillPlaceholder: "Pega código UPC o enlace de Apple/Spotify",
      autoFillButton: "Buscar",
      autoFillError: "Ingresa código UPC o enlace de Apple Music, Spotify, YouTube, Deezer, Tidal o SoundCloud",
      searchingLinks: "Buscando enlaces en todas las plataformas...",
      searchingUPC: "Buscando por código UPC...",
      linksFound: "enlaces encontrados y agregados",
      allLinksAdded: "Todos los enlaces disponibles ya están agregados",
      platformLinks: "Enlaces de plataformas",
      addLink: "Agregar enlace",
      selectPlatform: "Seleccionar plataforma",
      linkUrl: "URL del enlace",
      linkUrlPlaceholder: "https://...",
      customTitle: "Título personalizado (opcional)",
      appearance: "Apariencia",
      backgroundColor: "Color de fondo",
      textColor: "Color del texto",
      buttonStyle: "Estilo de botones",
      previewTitle: "Vista previa",
      saveChanges: "Guardar cambios",
      saveDraft: "Guardar borrador",
      publish: "Publicar",
      saving: "Guardando...",
      saved: "¡Guardado!",
      pageSaved: "Página guardada exitosamente",
      pagePublished: "Página publicada exitosamente",
      deleteLink: "Eliminar enlace",
      moveUp: "Mover arriba",
      moveDown: "Mover abajo",
      linkActive: "Enlace activo",
      linkInactive: "Enlace inactivo",
      qrCode: "Código QR",
      downloadQR: "Descargar QR",
      copyLink: "Copiar enlace",
      linkCopied: "Enlace copiado al portapapeles",
      openPage: "Abrir página",
      unsavedChanges: "Tienes cambios sin guardar",
      discardChanges: "¿Descartar cambios?",
      editing: "Editando",
      viewPage: "Ver Página",
      tabSettings: "Ajustes",
      tabPreview: "Vista previa",
      autofill: "Autocompletar",
      autofillDesc: "Pega código UPC o enlace — los datos y plataformas se llenarán automáticamente",
      autofillPlaceholder: "Pega código UPC o enlace de Apple Music, Spotify, Yandex Music, YouTube, Deezer, Tidal",
      autofillHint: "Ingresa código UPC o enlace de Apple Music, Spotify, Yandex Music, YouTube, Deezer, Tidal o SoundCloud",
      description: "Descripción (opcional)",
      descPlaceholder: "Cuenta sobre el lanzamiento...",
      coverHint: "Recomendado: 1000x1000px, JPG o PNG",
      noLinks: "Sin enlaces todavía. Agrega tu primer enlace arriba.",
      qrDesc: "Escanea para abrir la página",
      downloadPng: "Descargar PNG",
      enterUrlForQr: "Ingresa URL arriba para generar código QR",
      qrDisabled: "Código QR deshabilitado",
      pageCreated: "Página creada",
      pageUpdated: "Página actualizada",
      autoSaved: "Guardado",
      enterUrl: "Por favor ingresa URL",
      linkAdded: "Enlace agregado",
      linkDeleted: "Enlace eliminado",
      linksAdded: "Enlaces agregados",
      trackNotFound: "No se encontró la pista. Intenta con otro enlace.",
      upcNotFound: "No se encontró el lanzamiento por código UPC. Verifica el código.",
      scanError: "No se pudieron obtener enlaces. Verifica la URL e intenta de nuevo.",
      allLinksAdded: "Todos los enlaces disponibles ya están añadidos",
      linksWillAppear: "Los enlaces aparecerán aquí",
      pageDesign: "Diseño de Página",
      darkTheme: "Oscuro",
      lightTheme: "Claro",
      pageDesignHint: "Elige el tema para tu página pública",
      shareButtons: "Botones de acción",
      shareButtonsHint: "Muestra u oculta los botones de copiar y compartir en la página pública",
      deletePage: "Eliminar Página",
      confirmDelete: "¿Estás seguro de que quieres eliminar esta página?",
      deleteModalCancel: "Cancelar",
      deleteModalConfirm: "Eliminar",
      pageDeleted: "Página eliminada exitosamente",
      // Sidebar navigation
      sidebarRelease: "Lanzamiento",
      sidebarBasic: "Básico",
      sidebarBasicSettings: "Configuración de página",
      sidebarLinkAppearance: "Apariencia del enlace",
      sidebarAppearance: "Apariencia",
      sidebarPromotion: "Promoción",
      mobileTabSettings: "Ajustes",
      mobileTabPreview: "Vista previa",
      sidebarBasicSettingsDesc: "Configura los parámetros básicos de visualización de la página y agrega enlaces a servicios de música. Pegar un enlace de iTunes llenará automáticamente los campos básicos.",
      addLinkBtn: "Agregar enlace",
      addPresave: "Agregar presave",
      sortByClicks: "Ordenar por clics",
      artistSection: "Artista",
      changeBtn: "Cambiar",
      displayArtistName: "Nombre del artista mostrado",
      releaseName: "Lanzamiento",
      releaseDate: "Fecha de lanzamiento",
      previewPage: "Vista previa",
      pasteLinkPlaceholder: "Solo pega tu enlace aquí",
      editLinkUrl: "Editar enlace",
      saveLink: "Guardar",
      deletePageConfirm: "¿Estás seguro de que quieres eliminar esta página? Esta acción no se puede deshacer.",
    },
  },

  // ==================== ANALYTICS ====================
  analytics: {
    en: {
      title: "Analytics",
      subtitle: "Overview of all your pages statistics",
      pageAnalytics: "Page Analytics",
      overview: "Overview",
      totalViews: "Views",
      totalClicks: "Clicks",
      clickRate: "Click Rate",
      topPlatforms: "Top Platforms",
      viewsOverTime: "Views Over Time",
      clicksByPlatform: "Clicks by Platform",
      geography: "Geography",
      topCountries: "Top Countries",
      devices: "Devices",
      desktop: "Desktop",
      mobile: "Mobile",
      tablet: "Tablet",
      dateRange: "Date Range",
      last7Days: "Last 7 days",
      last30Days: "Last 30 days",
      last90Days: "Last 90 days",
      allTime: "All time",
      noData: "No data available",
      noDataDesc: "Start sharing your link to see analytics",
      export: "Export",
      refresh: "Refresh",
      realTime: "Real-time",
      proFeature: "Pro Feature",
      upgradeToSee: "Upgrade to Pro to see detailed analytics",
      shares: "Shares",
      qrScans: "QR Scans",
      dynamics: "Dynamics",
      clicksLast30: "Clicks for 30 days",
      noDataLast30: "No data for the last 30 days",
      shareTypes: "Distribution Methods",
      howShared: "How pages are shared",
      directLink: "Direct Link",
      qrCode: "QR Code",
      socialNetworks: "Social Networks",
      proRequired: "Available in PRO",
      geographyPro: "Click geography is available in PRO version",
      byCountry: "By Country",
      clickDistribution: "Click distribution",
      byCities: "By Cities",
      topCities: "Top cities",
      pageStats: "Page Statistics",
      detailedAnalytics: "Detailed analytics",
      detailedStats: "Detailed page statistics",
      views: "Views",
      noPages: "You have no pages yet",
    },
    ru: {
      title: "Аналитика",
      subtitle: "Обзор статистики всех ваших страниц",
      pageAnalytics: "Аналитика страницы",
      overview: "Обзор",
      totalViews: "Просмотров",
      totalClicks: "Кликов",
      clickRate: "Конверсия",
      topPlatforms: "Топ платформы",
      viewsOverTime: "Просмотры по времени",
      clicksByPlatform: "Клики по платформам",
      geography: "География",
      topCountries: "Топ страны",
      devices: "Устройства",
      desktop: "Компьютер",
      mobile: "Телефон",
      tablet: "Планшет",
      dateRange: "Период",
      last7Days: "Последние 7 дней",
      last30Days: "Последние 30 дней",
      last90Days: "Последние 90 дней",
      allTime: "Всё время",
      noData: "Нет данных",
      noDataDesc: "Начните делиться ссылкой, чтобы увидеть аналитику",
      export: "Экспорт",
      refresh: "Обновить",
      realTime: "В реальном времени",
      proFeature: "Pro функция",
      upgradeToSee: "Перейдите на Pro для детальной аналитики",
      shares: "Поделились",
      qrScans: "QR сканов",
      dynamics: "Динамика",
      clicksLast30: "Клики за 30 дней",
      noDataLast30: "Нет данных за последние 30 дней",
      shareTypes: "Способы распространения",
      howShared: "Как делятся страницами",
      directLink: "Прямая ссылка",
      qrCode: "QR-код",
      socialNetworks: "Соц. сети",
      proRequired: "Доступно в PRO",
      geographyPro: "География кликов доступна в PRO версии",
      byCountry: "По странам",
      clickDistribution: "Распределение кликов",
      byCities: "По городам",
      topCities: "Топ городов",
      pageStats: "Статистика по страницам",
      detailedAnalytics: "Детальная аналитика",
      detailedStats: "Детальная статистика по страницам",
      views: "Просм.",
      noPages: "У вас пока нет страниц",
    },
    es: {
      title: "Analíticas",
      subtitle: "Resumen de las estadísticas de todas tus páginas",
      pageAnalytics: "Analíticas de página",
      overview: "Resumen",
      totalViews: "Vistas",
      totalClicks: "Clics",
      clickRate: "Tasa de clics",
      topPlatforms: "Principales plataformas",
      viewsOverTime: "Vistas a lo largo del tiempo",
      clicksByPlatform: "Clics por plataforma",
      geography: "Geografía",
      topCountries: "Principales países",
      devices: "Dispositivos",
      desktop: "Escritorio",
      mobile: "Móvil",
      tablet: "Tablet",
      dateRange: "Rango de fechas",
      last7Days: "Últimos 7 días",
      last30Days: "Últimos 30 días",
      last90Days: "Últimos 90 días",
      allTime: "Todo el tiempo",
      noData: "Sin datos",
      noDataDesc: "Comienza a compartir tu enlace para ver analíticas",
      export: "Exportar",
      refresh: "Actualizar",
      realTime: "Tiempo real",
      proFeature: "Función Pro",
      upgradeToSee: "Mejora a Pro para ver analíticas detalladas",
      shares: "Compartidos",
      qrScans: "Escaneos QR",
      dynamics: "Dinámica",
      clicksLast30: "Clics en 30 días",
      noDataLast30: "Sin datos en los últimos 30 días",
      shareTypes: "Métodos de distribución",
      howShared: "Cómo se comparten las páginas",
      directLink: "Enlace directo",
      qrCode: "Código QR",
      socialNetworks: "Redes sociales",
      proRequired: "Disponible en PRO",
      geographyPro: "La geografía de clics está disponible en la versión PRO",
      byCountry: "Por País",
      clickDistribution: "Distribución de clics",
      byCities: "Por Ciudades",
      topCities: "Top ciudades",
      pageStats: "Estadísticas de páginas",
      detailedAnalytics: "Analíticas detalladas",
      detailedStats: "Estadísticas detalladas por página",
      views: "Vistas",
      noPages: "Aún no tienes páginas",
    },
  },

  // ==================== SETTINGS ====================
  settings: {
    en: {
      title: "Settings",
      profile: "Profile",
      account: "Account",
      appearance: "Appearance",
      notifications: "Notifications",
      security: "Security",
      billing: "Billing",
      profilePhoto: "Profile Photo",
      changePhoto: "Change Photo",
      displayName: "Display Name",
      bio: "Bio",
      bioPlaceholder: "Tell us about yourself",
      website: "Website",
      socialLinks: "Social Links",
      changeEmail: "Change Email",
      changePassword: "Change Password",
      currentPassword: "Current Password",
      newPassword: "New Password",
      confirmNewPassword: "Confirm New Password",
      twoFactor: "Two-Factor Authentication",
      enable2FA: "Enable 2FA",
      disable2FA: "Disable 2FA",
      deleteAccount: "Delete Account",
      deleteAccountWarning: "This action cannot be undone. All your data will be permanently deleted.",
      theme: "Theme",
      lightTheme: "Light",
      darkTheme: "Dark",
      systemTheme: "System",
      language: "Language",
      emailNotifications: "Email Notifications",
      pushNotifications: "Push Notifications",
      marketingEmails: "Marketing Emails",
      weeklyReport: "Weekly Report",
      settingsSaved: "Settings saved successfully",
      avatar: "Avatar",
      background: "Background",
    },
    ru: {
      title: "Настройки",
      profile: "Профиль",
      account: "Аккаунт",
      appearance: "Внешний вид",
      notifications: "Уведомления",
      security: "Безопасность",
      billing: "Оплата",
      profilePhoto: "Фото профиля",
      changePhoto: "Изменить фото",
      displayName: "Отображаемое имя",
      bio: "О себе",
      bioPlaceholder: "Расскажите о себе",
      website: "Сайт",
      socialLinks: "Соцсети",
      changeEmail: "Изменить email",
      changePassword: "Изменить пароль",
      currentPassword: "Текущий пароль",
      newPassword: "Новый пароль",
      confirmNewPassword: "Подтвердите новый пароль",
      twoFactor: "Двухфакторная аутентификация",
      enable2FA: "Включить 2FA",
      disable2FA: "Выключить 2FA",
      deleteAccount: "Удалить аккаунт",
      deleteAccountWarning: "Это действие нельзя отменить. Все ваши данные будут удалены навсегда.",
      theme: "Тема",
      lightTheme: "Светлая",
      darkTheme: "Тёмная",
      systemTheme: "Системная",
      language: "Язык",
      emailNotifications: "Email уведомления",
      pushNotifications: "Push уведомления",
      marketingEmails: "Рекламные письма",
      weeklyReport: "Еженедельный отчёт",
      settingsSaved: "Настройки сохранены",
      avatar: "Аватар",
      background: "Фон",
    },
    es: {
      title: "Ajustes",
      profile: "Perfil",
      account: "Cuenta",
      appearance: "Apariencia",
      notifications: "Notificaciones",
      security: "Seguridad",
      billing: "Facturación",
      profilePhoto: "Foto de perfil",
      changePhoto: "Cambiar foto",
      displayName: "Nombre visible",
      bio: "Biografía",
      bioPlaceholder: "Cuéntanos sobre ti",
      website: "Sitio web",
      socialLinks: "Redes sociales",
      changeEmail: "Cambiar correo",
      changePassword: "Cambiar contraseña",
      currentPassword: "Contraseña actual",
      newPassword: "Nueva contraseña",
      confirmNewPassword: "Confirmar nueva contraseña",
      twoFactor: "Autenticación de dos factores",
      enable2FA: "Activar 2FA",
      disable2FA: "Desactivar 2FA",
      deleteAccount: "Eliminar cuenta",
      deleteAccountWarning: "Esta acción no se puede deshacer. Todos tus datos serán eliminados permanentemente.",
      theme: "Tema",
      lightTheme: "Claro",
      darkTheme: "Oscuro",
      systemTheme: "Sistema",
      language: "Idioma",
      emailNotifications: "Notificaciones por correo",
      pushNotifications: "Notificaciones push",
      marketingEmails: "Correos de marketing",
      weeklyReport: "Informe semanal",
      settingsSaved: "Ajustes guardados exitosamente",
      avatar: "Avatar",
      background: "Fondo",
    },
  },

  // ==================== ERRORS ====================
  errors: {
    en: {
      generic: "Something went wrong. Please try again.",
      network: "Network error. Please check your connection.",
      notFound: "Page not found",
      notFoundDesc: "The page you're looking for doesn't exist or has been moved.",
      unauthorized: "You need to sign in to access this page",
      forbidden: "You don't have permission to access this page",
      serverError: "Server error. Please try again later.",
      validationError: "Please check your input and try again",
      sessionExpired: "Your session has expired. Please sign in again.",
      rateLimited: "Too many requests. Please wait a moment.",
      fileTooBig: "File is too large. Maximum size is",
      invalidFileType: "Invalid file type. Allowed types:",
      uploadFailed: "Upload failed. Please try again.",
      saveFailed: "Failed to save. Please try again.",
      deleteFailed: "Failed to delete. Please try again.",
      copyFailed: "Failed to copy. Please try again.",
      loadFailed: "Failed to load data. Please refresh the page.",
      goHome: "Go to Home",
      goBack: "Go Back",
      tryAgain: "Try Again",
      contactSupport: "Contact Support",
    },
    ru: {
      generic: "Что-то пошло не так. Попробуйте ещё раз.",
      network: "Ошибка сети. Проверьте подключение к интернету.",
      notFound: "Страница не найдена",
      notFoundDesc: "Страница, которую вы ищете, не существует или была перемещена.",
      unauthorized: "Войдите в аккаунт, чтобы получить доступ к этой странице",
      forbidden: "У вас нет доступа к этой странице",
      serverError: "Ошибка сервера. Попробуйте позже.",
      validationError: "Проверьте введённые данные и попробуйте снова",
      sessionExpired: "Сессия истекла. Войдите снова.",
      rateLimited: "Слишком много запросов. Подождите немного.",
      fileTooBig: "Файл слишком большой. Максимальный размер:",
      invalidFileType: "Недопустимый тип файла. Разрешённые типы:",
      uploadFailed: "Ошибка загрузки. Попробуйте снова.",
      saveFailed: "Не удалось сохранить. Попробуйте снова.",
      deleteFailed: "Не удалось удалить. Попробуйте снова.",
      copyFailed: "Не удалось скопировать. Попробуйте снова.",
      loadFailed: "Не удалось загрузить данные. Обновите страницу.",
      goHome: "На главную",
      goBack: "Назад",
      tryAgain: "Попробовать снова",
      contactSupport: "Связаться с поддержкой",
    },
    es: {
      generic: "Algo salió mal. Por favor intenta de nuevo.",
      network: "Error de red. Por favor verifica tu conexión.",
      notFound: "Página no encontrada",
      notFoundDesc: "La página que buscas no existe o ha sido movida.",
      unauthorized: "Necesitas iniciar sesión para acceder a esta página",
      forbidden: "No tienes permiso para acceder a esta página",
      serverError: "Error del servidor. Por favor intenta más tarde.",
      validationError: "Por favor verifica tus datos e intenta de nuevo",
      sessionExpired: "Tu sesión ha expirado. Por favor inicia sesión de nuevo.",
      rateLimited: "Demasiadas solicitudes. Por favor espera un momento.",
      fileTooBig: "El archivo es muy grande. El tamaño máximo es",
      invalidFileType: "Tipo de archivo inválido. Tipos permitidos:",
      uploadFailed: "Error al subir. Por favor intenta de nuevo.",
      saveFailed: "Error al guardar. Por favor intenta de nuevo.",
      deleteFailed: "Error al eliminar. Por favor intenta de nuevo.",
      copyFailed: "Error al copiar. Por favor intenta de nuevo.",
      loadFailed: "Error al cargar datos. Por favor actualiza la página.",
      goHome: "Ir al inicio",
      goBack: "Volver",
      tryAgain: "Intentar de nuevo",
      contactSupport: "Contactar soporte",
    },
  },

  // ==================== SIDEBAR ====================
  sidebar: {
    en: {
      myPages: "My Pages",
      createPage: "Create Page",
      analytics: "Analytics",
      chart: "Chart",
      promo: "Promo",
      domains: "Domains",
      settings: "Settings",
      support: "Support",
      verification: "Verification",
      admin: "Admin Panel",
      collapse: "Collapse",
      expand: "Expand",
    },
    ru: {
      myPages: "Мультиссылки",
      createPage: "Создать страницу",
      analytics: "Аналитика",
      chart: "Чарт",
      promo: "Промо",
      domains: "Домены",
      settings: "Настройки",
      support: "Поддержка",
      verification: "Верификация",
      admin: "Админ панель",
      collapse: "Свернуть",
      expand: "Развернуть",
    },
    es: {
      myPages: "Mis páginas",
      createPage: "Crear página",
      analytics: "Analíticas",
      chart: "Chart",
      promo: "Promo",
      domains: "Dominios",
      settings: "Ajustes",
      support: "Soporte",
      verification: "Verificación",
      admin: "Panel admin",
      collapse: "Colapsar",
      expand: "Expandir",
    },
  },

  // ==================== PRICING ====================
  pricing: {
    en: {
      title: "Pricing",
      subtitle: "Choose the plan that's right for you",
      monthly: "Monthly",
      yearly: "Yearly",
      savePercent: "Save",
      freePlan: "Free",
      proPlan: "Pro",
      freePlanDesc: "Perfect for getting started",
      proPlanDesc: "For serious creators",
      currentPlan: "Current Plan",
      upgradeToPro: "Upgrade to Pro",
      features: "Features",
      freeFeatures: [
        "1 smart link page",
        "Basic analytics",
        "Standard support",
        "Mus.Link subdomain",
      ],
      proFeatures: [
        "Unlimited pages",
        "Advanced analytics",
        "Priority support",
        "Custom subdomains",
        "No Mus.Link branding",
        "API access",
      ],
      perMonth: "/month",
      perYear: "/year",
      faq: "Frequently Asked Questions",
    },
    ru: {
      title: "Тарифы",
      subtitle: "Выберите подходящий план",
      monthly: "Ежемесячно",
      yearly: "Ежегодно",
      savePercent: "Скидка",
      freePlan: "Бесплатный",
      proPlan: "Pro",
      freePlanDesc: "Отлично для начала",
      proPlanDesc: "Для серьёзных создателей",
      currentPlan: "Текущий план",
      upgradeToPro: "Перейти на Pro",
      features: "Возможности",
      freeFeatures: [
        "1 смарт-ссылка",
        "Базовая аналитика",
        "Стандартная поддержка",
        "Поддомен Mus.Link",
      ],
      proFeatures: [
        "Безлимит страниц",
        "Расширенная аналитика",
        "Приоритетная поддержка",
        "Свои поддомены",
        "Без брендинга Mus.Link",
        "Доступ к API",
      ],
      perMonth: "/месяц",
      perYear: "/год",
      faq: "Часто задаваемые вопросы",
    },
    es: {
      title: "Precios",
      subtitle: "Elige el plan adecuado para ti",
      monthly: "Mensual",
      yearly: "Anual",
      savePercent: "Ahorra",
      freePlan: "Gratis",
      proPlan: "Pro",
      freePlanDesc: "Perfecto para empezar",
      proPlanDesc: "Para creadores serios",
      currentPlan: "Plan actual",
      upgradeToPro: "Mejorar a Pro",
      features: "Características",
      freeFeatures: [
        "1 página de enlace inteligente",
        "Analíticas básicas",
        "Soporte estándar",
        "Subdominio Mus.Link",
      ],
      proFeatures: [
        "Páginas ilimitadas",
        "Analíticas avanzadas",
        "Soporte prioritario",
        "Subdominios personalizados",
        "Sin marca Mus.Link",
        "Acceso a API",
      ],
      perMonth: "/mes",
      perYear: "/año",
      faq: "Preguntas frecuentes",
    },
  },

  // ==================== DOMAINS (SUBDOMAINS) ====================
  domains: {
    en: {
      title: "Account Subdomain",
      subtitle: "Create one permanent Mus.Link subdomain for your account",
      addDomain: "Create subdomain",
      domainPlaceholder: "yourname",
      verifyDomain: "Verify",
      removeDomain: "Remove",
      domainStatus: "Status",
      pending: "Pending",
      verified: "Active",
      failed: "Blocked",
      instructions: "Important details",
      step1: "Each account can create one subdomain only (e.g., artistname.mus.link)",
      step2: "The subdomain is permanent and cannot be changed after creation",
      step3: "Generic terms such as music, audio, playlist, album, artist and similar names are not available",
      dnsSettings: "Your subdomain",
      record: "Address",
      type: "Type",
      value: "Value",
      proRequired: "Only one subdomain is available per account",
      oneSubdomainOnly: "Each account can have only one subdomain. It cannot be changed after creation.",
      immutable: "Cannot be changed",
    },
    ru: {
      title: "Поддомен аккаунта",
      subtitle: "Создайте один постоянный поддомен Mus.Link для аккаунта",
      addDomain: "Создать поддомен",
      domainPlaceholder: "sub",
      verifyDomain: "Проверить",
      removeDomain: "Удалить",
      domainStatus: "Статус",
      pending: "Ожидание",
      verified: "Активен",
      failed: "Заблокирован",
      instructions: "Важная информация",
      step1: "На один аккаунт можно создать только один поддомен (например, artistname.mus.link)",
      step2: "Поддомен закрепляется навсегда и не меняется после создания",
      step3: "Общие слова вроде music, audio, playlist, album, artist и похожие названия недоступны",
      dnsSettings: "Ваш поддомен",
      record: "Адрес",
      type: "Тип",
      value: "Значение",
      proRequired: "На аккаунт доступен только один поддомен",
      oneSubdomainOnly: "На один аккаунт доступен только один поддомен. После создания изменить его нельзя.",
      immutable: "Нельзя изменить",
    },
    es: {
      title: "Subdominio de la cuenta",
      subtitle: "Crea un subdominio permanente de Mus.Link para tu cuenta",
      addDomain: "Crear subdominio",
      domainPlaceholder: "tunombre",
      verifyDomain: "Verificar",
      removeDomain: "Eliminar",
      domainStatus: "Estado",
      pending: "Pendiente",
      verified: "Activo",
      failed: "Bloqueado",
      instructions: "Información importante",
      step1: "Cada cuenta puede crear solo un subdominio (ej., artistname.mus.link)",
      step2: "El subdominio es permanente y no se puede cambiar después de crearlo",
      step3: "Términos genéricos como music, audio, playlist, album, artist y nombres similares no están disponibles",
      dnsSettings: "Tu subdominio",
      record: "Dirección",
      type: "Tipo",
      value: "Valor",
      proRequired: "Solo hay un subdominio disponible por cuenta",
      oneSubdomainOnly: "Cada cuenta puede tener solo un subdominio. No se puede cambiar después de crearlo.",
      immutable: "No se puede cambiar",
    },
  },

  // ==================== PUBLIC PAGE ====================
  publicPage: {
    en: {
      listenOn: "Listen on",
      share: "Share",
      qrCode: "QR Code",
      copyLink: "Copy Link",
      copy: "Copy",
      linkCopied: "Link copied!",
      poweredBy: "Powered by Mus.Link",
      moreLinks: "More",
      scanToShare: "Scan to share",
      verifiedArtist: "Verified artist",
    },
    ru: {
      listenOn: "Слушать на",
      share: "Поделиться",
      qrCode: "QR-код",
      copyLink: "Копировать ссылку",
      copy: "Скопировать",
      linkCopied: "Ссылка скопирована!",
      poweredBy: "Создано в Mus.Link",
      moreLinks: "Ещё",
      scanToShare: "Сканируйте, чтобы поделиться",
      verifiedArtist: "Артист подтверждён",
    },
    es: {
      listenOn: "Escuchar en",
      share: "Compartir",
      qrCode: "Código QR",
      copyLink: "Copiar enlace",
      copy: "Copiar",
      linkCopied: "¡Enlace copiado!",
      poweredBy: "Creado con Mus.Link",
      moreLinks: "Más",
      scanToShare: "Escanea para compartir",
      verifiedArtist: "Artista verificado",
    },
  },

  // ==================== ADMIN ====================
  admin: {
    en: {
      title: "Admin Panel",
      overview: "Overview",
      users: "Users",
      pages: "Pages",
      analytics: "Analytics",
      settings: "Settings",
      totalUsers: "Users",
      totalPages: "Pages",
      totalViews: "Views",
      totalClicks: "Clicks",
      totalShares: "Shares",
      totalQrScans: "QR Scans",
      newUsersToday: "New Users Today",
      userManagement: "User Management",
      searchUsers: "Search users...",
      role: "Role",
      status: "Status",
      plan: "Plan",
      actions: "Actions",
      banUser: "Ban User",
      unbanUser: "Unban User",
      deleteUser: "Delete User",
      makeAdmin: "Make Admin",
      removeAdmin: "Remove Admin",
      owner: "Owner",
      moderator: "Moderator",
      banned: "Banned",
      verified: "Verified",
      planConfig: "Plan Configuration",
      testSubscription: "Test Subscription",
      yourCurrentPlan: "Your current plan:",
      forTesting: "(for testing)",
      testSubscriptions: "Subscription Testing",
      yourPlan: "Your current plan",
      globalAnalytics: "Global Analytics",
      plans: "Plans",
      tickets: "Tickets",
      requests: "Requests",
      approved: "Approved",
      rejected: "Rejected",
      moderators: "Moderators",
      admins: "Admins",
      owners: "Owners",
      activity30Days: "Activity (30 days)",
      days30: "30 days",
      clicks: "Clicks",
      noData: "No data",
      geographyClicks: "Click Geography",
      unknown: "Unknown",
      planDistribution: "Plan Distribution",
      userStatus: "User Status",
      active: "Active",
      bannedUsers: "Banned",
      verifiedUsers: "Verified",
      activePages: "Active Pages",
      pagesCount: "pages",
      ban: "Ban",
      revoke: "Revoke",
      grant: "Grant",
      usersCount: "users",
      pagesLimit: "Pages Limit",
      subdomainsLimit: "Subdomains Limit",
      unlimited: "-1 = unlimited",
      disabled: "0 = disabled",
      basicAnalytics: "Basic Analytics",
      advancedAnalytics: "Advanced Analytics",
      aiGeneration: "AI Cover Generation",
      profileVerification: "Profile Verification",
      removeBranding: "Remove Branding",
      prioritySupport: "Priority Support",
      saveChanges: "Save Changes",
      pagesList: "All Pages",
      slug: "Slug",
      views: "Views",
      disablePage: "Disable",
      enablePage: "Enable",
      deletePage: "Delete",
      subdomainsList: "All Subdomains",
      searchSubdomains: "Search subdomains...",
      subdomain: "Subdomain",
      user: "User",
      disableSubdomain: "Disable",
      enableSubdomain: "Enable",
      deleteSubdomain: "Delete",
      verificationRequests: "Verification Requests",
      pendingRequests: "Pending Requests",
      approve: "Approve",
      reject: "Reject",
      vpsMonitoring: "VPS Monitoring",
      systemResources: "System Resources",
      cpu: "CPU",
      ram: "RAM",
      disk: "Disk",
      used: "used",
      uptime: "Uptime",
      days: "days",
      hours: "hours",
      minutes: "minutes",
      osInfo: "OS Info",
      os: "OS",
      kernel: "Kernel",
      hostname: "Hostname",
      publicIP: "Public IP",
      updateStatus: "Update Status",
      available: "available",
      ticketsList: "Support Tickets",
      filterByStatus: "Filter by status",
      allStatuses: "All statuses",
      open: "Open",
      inProgress: "In Progress",
      resolved: "Resolved",
      closed: "Closed",
      noTickets: "No tickets",
      ticketFrom: "From",
      reply: "Reply",
      changeStatus: "Change Status",
      replyPlaceholder: "Write your reply...",
      sendReply: "Send Reply",
      // Plan changes
      planChanged: "Plan changed",
      planChangedForTesting: "Your plan has been changed for testing",
      verificationRevoked: "Verification revoked",
      verified: "Verified",
      // Roles
      roleOwner: "Owner",
      roleAdmin: "Admin",
      roleModerator: "Moderator",
      roleUser: "User",
      // User Profile Modal
      profile: "Profile",
      viewProfile: "View Profile",
      registrationDate: "Registration Date",
      userPages: "User Pages",
      created: "Created",
      updated: "Updated",
      role: "Role",
      plan: "Plan",
      status: "Status",
      totalClicks: "Total Clicks",
      clicks7d: "Last 7 days",
      active: "Active",
      disabled: "Disabled",
      banned: "Banned",
      verifiedBadge: "Verified",
      noPages: "User has no pages yet",
      viewPublicPage: "View Public Page",
      editPage: "Edit",
      profileLoadError: "Failed to load profile",
      // Ticket statuses
      ticketOpen: "Open",
      ticketInProgress: "In Progress",
      ticketResolved: "Resolved",
      ticketClosed: "Closed",
      // Toast messages
      ticketLoadError: "Failed to load ticket",
      replySent: "Reply sent",
      replyError: "Failed to send reply",
      statusUpdated: "Status updated",
      statusUpdateError: "Failed to update status",
      subdomainUnblocked: "Subdomain unblocked",
      subdomainBlocked: "Subdomain blocked",
      subdomainDeleted: "Subdomain deleted",
      subdomainDeleteConfirm: "Delete subdomain? This action cannot be undone.",
      userUnbanned: "User unbanned",
      userBanned: "User banned",
      roleChanged: "Role changed",
      // Tickets section
      allStatuses: "All statuses",
      openTickets: "Open",
      inProgressTickets: "In Progress",
      resolvedTickets: "Resolved",
      closedTickets: "Closed",
      unreadCount: "unread",
      noTicketsFound: "No tickets found",
      selectTicket: "Select a ticket to view",
      yourReply: "Your reply...",
      sendReplyBtn: "Send Reply",
      supportTeam: "Support",
      supportAgent: "Support Agent",
      // Verification section
      socialLinks: "Social links",
      approveBtn: "Approve",
      rejectBtn: "Reject",
      noPendingRequests: "No pending requests",
      // VPS section
      memory: "Memory",
      disk: "Disk",
      network: "Network",
      sent: "Sent",
      received: "Received",
      uptime: "Uptime",
      loadingMetrics: "Loading metrics...",
      // Countries
      countryRussia: "Russia",
      countryUSA: "USA",
      countryUkraine: "Ukraine",
      countryBelarus: "Belarus",
      countryKazakhstan: "Kazakhstan",
      countryGermany: "Germany",
      countryUK: "United Kingdom",
      countryFrance: "France",
      countryHongKong: "Hong Kong",
      countrySingapore: "Singapore",
      countryUnknown: "Unknown",
      // E-Mails (Waitlist)
      waitlistEmails: "Waitlist E-Mails",
      waitlistDesc: "Users interested in PRO features",
      noWaitlistEmails: "No waitlist emails yet",
      deleteEmailConfirm: "Delete this email from waitlist?",
      emailDeleted: "Email deleted",
      total: "Total",
    },
    ru: {
      title: "Админ панель",
      overview: "Обзор",
      users: "Пользователи",
      pages: "Страницы",
      analytics: "Аналитика",
      settings: "Настройки",
      totalUsers: "Пользователей",
      totalPages: "Страниц",
      totalViews: "Просмотров",
      totalClicks: "Кликов",
      totalShares: "Репостов",
      totalQrScans: "QR сканов",
      newUsersToday: "Новых сегодня",
      userManagement: "Управление пользователями",
      searchUsers: "Поиск пользователей...",
      role: "Роль",
      status: "Статус",
      plan: "План",
      actions: "Действия",
      banUser: "Заблокировать",
      unbanUser: "Разблокировать",
      deleteUser: "Удалить",
      makeAdmin: "Сделать админом",
      removeAdmin: "Убрать админа",
      owner: "Владелец",
      moderator: "Модератор",
      banned: "Заблокирован",
      verified: "Верифицирован",
      planConfig: "Настройки планов",
      testSubscription: "Тестирование подписок",
      yourCurrentPlan: "Ваш текущий план:",
      forTesting: "(для тестирования)",
      testSubscriptions: "Тестирование подписок",
      yourPlan: "Ваш текущий план",
      globalAnalytics: "Глобальная аналитика",
      plans: "Планы",
      tickets: "Тикеты",
      requests: "Заявки",
      approved: "Одобрено",
      rejected: "Отклонено",
      moderators: "Модераторы",
      admins: "Админы",
      owners: "Владельцы",
      activity30Days: "Активность за 30 дней",
      days30: "30 дней",
      clicks: "Клики",
      noData: "Нет данных",
      geographyClicks: "География кликов",
      unknown: "Неизвестно",
      planDistribution: "Распределение по планам",
      userStatus: "Статус пользователей",
      active: "Активных",
      bannedUsers: "Забанено",
      verifiedUsers: "Верифицировано",
      activePages: "Активных страниц",
      pagesCount: "стр.",
      ban: "Бан",
      revoke: "Снять",
      grant: "Выдать",
      usersCount: "пользователей",
      pagesLimit: "Лимит страниц",
      subdomainsLimit: "Лимит поддоменов",
      unlimited: "-1 = безлимит",
      disabled: "0 = запрещено",
      basicAnalytics: "Базовая аналитика",
      advancedAnalytics: "Расширенная аналитика",
      aiGeneration: "AI генерация обложек",
      profileVerification: "Верификация профиля",
      removeBranding: "Убрать брендинг",
      prioritySupport: "Приоритетная поддержка",
      saveChanges: "Сохранить изменения",
      pagesList: "Все страницы",
      slug: "Адрес",
      views: "Просм.",
      disablePage: "Отключить",
      enablePage: "Включить",
      deletePage: "Удалить",
      subdomainsList: "Все поддомены",
      searchSubdomains: "Поиск поддоменов...",
      subdomain: "Поддомен",
      user: "Пользователь",
      disableSubdomain: "Отключить",
      enableSubdomain: "Включить",
      deleteSubdomain: "Удалить",
      verificationRequests: "Заявки на верификацию",
      pendingRequests: "Ожидающие заявки",
      approve: "Одобрить",
      reject: "Отклонить",
      vpsMonitoring: "Мониторинг VPS",
      systemResources: "Системные ресурсы",
      cpu: "CPU",
      ram: "RAM",
      disk: "Диск",
      used: "занято",
      uptime: "Аптайм",
      days: "дней",
      hours: "часов",
      minutes: "минут",
      osInfo: "Информация об ОС",
      os: "ОС",
      kernel: "Ядро",
      hostname: "Hostname",
      publicIP: "Публичный IP",
      updateStatus: "Статус обновлений",
      available: "доступно",
      ticketsList: "Тикеты поддержки",
      filterByStatus: "Фильтр по статусу",
      allStatuses: "Все статусы",
      open: "Открыт",
      inProgress: "В работе",
      resolved: "Решён",
      closed: "Закрыт",
      noTickets: "Нет тикетов",
      ticketFrom: "От",
      reply: "Ответить",
      changeStatus: "Сменить статус",
      replyPlaceholder: "Напишите ваш ответ...",
      sendReply: "Отправить",
      // Plan changes
      planChanged: "План изменён",
      planChangedForTesting: "Ваш план изменён для тестирования",
      verificationRevoked: "Верификация снята",
      verified: "Верифицирован",
      // Roles
      roleOwner: "Владелец",
      roleAdmin: "Админ",
      roleModerator: "Модератор",
      roleUser: "Пользователь",
      // User Profile Modal
      profile: "Профиль",
      viewProfile: "Просмотр профиля",
      registrationDate: "Дата регистрации",
      userPages: "Страницы пользователя",
      created: "Создана",
      updated: "Обновлена",
      role: "Роль",
      plan: "План",
      status: "Статус",
      totalClicks: "Всего кликов",
      clicks7d: "За 7 дней",
      active: "Активен",
      disabled: "Отключена",
      banned: "Заблокирован",
      verifiedBadge: "Верифицирован",
      noPages: "Пользователь ещё не создал страниц",
      viewPublicPage: "Открыть страницу",
      editPage: "Редактировать",
      profileLoadError: "Не удалось загрузить профиль",
      // Ticket statuses
      ticketOpen: "Открыт",
      ticketInProgress: "В работе",
      ticketResolved: "Решён",
      ticketClosed: "Закрыт",
      // Toast messages
      ticketLoadError: "Не удалось загрузить тикет",
      replySent: "Ответ отправлен",
      replyError: "Не удалось отправить ответ",
      statusUpdated: "Статус обновлён",
      statusUpdateError: "Не удалось обновить статус",
      subdomainUnblocked: "Поддомен разблокирован",
      subdomainBlocked: "Поддомен заблокирован",
      subdomainDeleted: "Поддомен удалён",
      subdomainDeleteConfirm: "Удалить поддомен? Это действие необратимо.",
      userUnbanned: "Пользователь разбанен",
      userBanned: "Пользователь забанен",
      roleChanged: "Роль изменена",
      // Tickets section
      allStatuses: "Все статусы",
      openTickets: "Открытые",
      inProgressTickets: "В работе",
      resolvedTickets: "Решённые",
      closedTickets: "Закрытые",
      unreadCount: "непрочитанных",
      noTicketsFound: "Тикеты не найдены",
      selectTicket: "Выберите тикет для просмотра",
      yourReply: "Ваш ответ...",
      sendReplyBtn: "Отправить ответ",
      supportTeam: "Поддержка",
      supportAgent: "Агент поддержки",
      // Verification section
      socialLinks: "Соц. сети",
      approveBtn: "Одобрить",
      rejectBtn: "Отклонить",
      noPendingRequests: "Нет ожидающих заявок",
      // VPS section
      memory: "Память",
      disk: "Диск",
      network: "Сеть",
      sent: "Отправлено",
      received: "Получено",
      uptime: "Аптайм",
      loadingMetrics: "Загрузка метрик...",
      // Countries
      countryRussia: "Россия",
      countryUSA: "США",
      countryUkraine: "Украина",
      countryBelarus: "Беларусь",
      countryKazakhstan: "Казахстан",
      countryGermany: "Германия",
      countryUK: "Великобритания",
      countryFrance: "Франция",
      countryHongKong: "Гонконг",
      countrySingapore: "Сингапур",
      countryUnknown: "Неизвестно",
      // E-Mails (Waitlist)
      waitlistEmails: "E-Mails (Waitlist)",
      waitlistDesc: "Пользователи, заинтересованные в PRO функциях",
      noWaitlistEmails: "Нет e-mail в списке ожидания",
      deleteEmailConfirm: "Удалить этот e-mail из списка ожидания?",
      emailDeleted: "E-Mail удалён",
      total: "Всего",
    },
    es: {
      title: "Panel de Admin",
      overview: "Resumen",
      users: "Usuarios",
      pages: "Páginas",
      analytics: "Analíticas",
      settings: "Ajustes",
      totalUsers: "Usuarios",
      totalPages: "Páginas",
      totalViews: "Vistas",
      totalClicks: "Clics",
      totalShares: "Compartidos",
      totalQrScans: "Escaneos QR",
      newUsersToday: "Nuevos hoy",
      userManagement: "Gestión de usuarios",
      searchUsers: "Buscar usuarios...",
      role: "Rol",
      status: "Estado",
      plan: "Plan",
      actions: "Acciones",
      banUser: "Banear usuario",
      unbanUser: "Desbanear usuario",
      deleteUser: "Eliminar usuario",
      makeAdmin: "Hacer admin",
      removeAdmin: "Quitar admin",
      owner: "Propietario",
      moderator: "Moderador",
      banned: "Baneado",
      verified: "Verificado",
      planConfig: "Configuración de planes",
      testSubscription: "Probar suscripción",
      yourCurrentPlan: "Tu plan actual:",
      forTesting: "(para probar)",
      testSubscriptions: "Prueba de suscripciones",
      yourPlan: "Tu plan actual",
      globalAnalytics: "Analíticas Globales",
      plans: "Planes",
      tickets: "Tickets",
      requests: "Solicitudes",
      approved: "Aprobado",
      rejected: "Rechazado",
      moderators: "Moderadores",
      admins: "Admins",
      owners: "Propietarios",
      activity30Days: "Actividad (30 días)",
      days30: "30 días",
      clicks: "Clics",
      noData: "Sin datos",
      geographyClicks: "Geografía de clics",
      unknown: "Desconocido",
      planDistribution: "Distribución por plan",
      userStatus: "Estado de usuarios",
      active: "Activos",
      bannedUsers: "Baneados",
      verifiedUsers: "Verificados",
      activePages: "Páginas activas",
      pagesCount: "págs.",
      ban: "Ban",
      revoke: "Revocar",
      grant: "Otorgar",
      usersCount: "usuarios",
      pagesLimit: "Límite de páginas",
      subdomainsLimit: "Límite de subdominios",
      unlimited: "-1 = ilimitado",
      disabled: "0 = deshabilitado",
      basicAnalytics: "Analíticas básicas",
      advancedAnalytics: "Analíticas avanzadas",
      aiGeneration: "Generación IA de portadas",
      profileVerification: "Verificación de perfil",
      removeBranding: "Quitar marca",
      prioritySupport: "Soporte prioritario",
      saveChanges: "Guardar cambios",
      pagesList: "Todas las páginas",
      slug: "Slug",
      views: "Vistas",
      disablePage: "Deshabilitar",
      enablePage: "Habilitar",
      deletePage: "Eliminar",
      subdomainsList: "Todos los subdominios",
      searchSubdomains: "Buscar subdominios...",
      subdomain: "Subdominio",
      user: "Usuario",
      disableSubdomain: "Deshabilitar",
      enableSubdomain: "Habilitar",
      deleteSubdomain: "Eliminar",
      verificationRequests: "Solicitudes de verificación",
      pendingRequests: "Solicitudes pendientes",
      approve: "Aprobar",
      reject: "Rechazar",
      vpsMonitoring: "Monitoreo VPS",
      systemResources: "Recursos del sistema",
      cpu: "CPU",
      ram: "RAM",
      disk: "Disco",
      used: "usado",
      uptime: "Tiempo activo",
      days: "días",
      hours: "horas",
      minutes: "minutos",
      osInfo: "Info del SO",
      os: "SO",
      kernel: "Kernel",
      hostname: "Hostname",
      publicIP: "IP Pública",
      updateStatus: "Estado de actualizaciones",
      available: "disponible",
      ticketsList: "Tickets de soporte",
      filterByStatus: "Filtrar por estado",
      allStatuses: "Todos los estados",
      open: "Abierto",
      inProgress: "En progreso",
      resolved: "Resuelto",
      closed: "Cerrado",
      noTickets: "Sin tickets",
      ticketFrom: "De",
      reply: "Responder",
      changeStatus: "Cambiar estado",
      replyPlaceholder: "Escribe tu respuesta...",
      sendReply: "Enviar",
      // Plan changes
      planChanged: "Plan cambiado",
      planChangedForTesting: "Tu plan ha sido cambiado para pruebas",
      verificationRevoked: "Verificación revocada",
      verified: "Verificado",
      // Roles
      roleOwner: "Propietario",
      roleAdmin: "Admin",
      roleModerator: "Moderador",
      roleUser: "Usuario",
      // User Profile Modal
      profile: "Perfil",
      viewProfile: "Ver perfil",
      registrationDate: "Fecha de registro",
      userPages: "Páginas del usuario",
      created: "Creada",
      updated: "Actualizada",
      role: "Rol",
      plan: "Plan",
      status: "Estado",
      totalClicks: "Clics totales",
      clicks7d: "Últimos 7 días",
      active: "Activo",
      banned: "Bloqueado",
      verifiedBadge: "Verificado",
      noPages: "El usuario aún no ha creado páginas",
      viewPublicPage: "Ver página pública",
      editPage: "Editar",
      profileLoadError: "No se pudo cargar el perfil",
      // Ticket statuses
      ticketOpen: "Abierto",
      ticketInProgress: "En progreso",
      ticketResolved: "Resuelto",
      ticketClosed: "Cerrado",
      // Toast messages
      ticketLoadError: "No se pudo cargar el ticket",
      replySent: "Respuesta enviada",
      replyError: "No se pudo enviar la respuesta",
      statusUpdated: "Estado actualizado",
      statusUpdateError: "No se pudo actualizar el estado",
      subdomainUnblocked: "Subdominio desbloqueado",
      subdomainBlocked: "Subdominio bloqueado",
      subdomainDeleted: "Subdominio eliminado",
      subdomainDeleteConfirm: "¿Eliminar subdominio? Esta acción es irreversible.",
      userUnbanned: "Usuario desbaneado",
      userBanned: "Usuario baneado",
      roleChanged: "Rol cambiado",
      // Tickets section
      openTickets: "Abiertos",
      inProgressTickets: "En progreso",
      resolvedTickets: "Resueltos",
      closedTickets: "Cerrados",
      unreadCount: "sin leer",
      noTicketsFound: "No se encontraron tickets",
      selectTicket: "Selecciona un ticket para ver",
      yourReply: "Tu respuesta...",
      sendReplyBtn: "Enviar respuesta",
      supportTeam: "Soporte",
      supportAgent: "Agente de soporte",
      // Verification section
      socialLinks: "Redes sociales",
      approveBtn: "Aprobar",
      rejectBtn: "Rechazar",
      noPendingRequests: "No hay solicitudes pendientes",
      // VPS section
      memory: "Memoria",
      disk: "Disco",
      network: "Red",
      sent: "Enviado",
      received: "Recibido",
      uptime: "Tiempo activo",
      loadingMetrics: "Cargando métricas...",
      // Countries
      countryRussia: "Rusia",
      countryUSA: "EE.UU.",
      countryUkraine: "Ucrania",
      countryBelarus: "Bielorrusia",
      countryKazakhstan: "Kazajistán",
      countryGermany: "Alemania",
      countryUK: "Reino Unido",
      countryFrance: "Francia",
      countryHongKong: "Hong Kong",
      countrySingapore: "Singapur",
      countryUnknown: "Desconocido",
      // E-Mails (Waitlist)
      waitlistEmails: "E-Mails (Lista de espera)",
      waitlistDesc: "Usuarios interesados en funciones PRO",
      noWaitlistEmails: "No hay emails en la lista de espera",
      deleteEmailConfirm: "¿Eliminar este email de la lista de espera?",
      emailDeleted: "Email eliminado",
      total: "Total",
    },
  },

  // ==================== VERIFICATION ====================
  verification: {
    en: {
      title: "Verification",
      subtitle: "Get verified and increase trust",
      status: "Verification Status",
      notVerified: "Not Verified",
      pending: "Pending Review",
      approved: "Verified",
      rejected: "Rejected",
      applyTitle: "Apply for Verification",
      applyDesc: "Verified accounts get a badge and increased visibility",
      requirements: "Requirements",
      req1: "Complete profile information",
      req2: "At least one published page",
      req3: "Active account for 7+ days",
      applyButton: "Apply for Verification",
      applying: "Submitting...",
      applicationSent: "Application submitted successfully",
      alreadyApplied: "You have already applied",
      benefits: "Benefits of Verification",
      benefit1: "Verified badge on profile",
      benefit2: "Increased trust from visitors",
      benefit3: "Priority in search results",
      showBadge: "Show verification badge",
      hideBadge: "Hide verification badge",
      badgeUpdated: "Badge visibility updated",
    },
    ru: {
      title: "Верификация",
      subtitle: "Получите верификацию и повысьте доверие",
      status: "Статус верификации",
      notVerified: "Не верифицирован",
      pending: "На рассмотрении",
      approved: "Верифицирован",
      rejected: "Отклонено",
      applyTitle: "Подать заявку на верификацию",
      applyDesc: "Верифицированные аккаунты получают значок и повышенную видимость",
      requirements: "Требования",
      req1: "Заполненная информация профиля",
      req2: "Минимум одна опубликованная страница",
      req3: "Активный аккаунт более 7 дней",
      applyButton: "Подать заявку",
      applying: "Отправка...",
      applicationSent: "Заявка успешно отправлена",
      alreadyApplied: "Вы уже подали заявку",
      benefits: "Преимущества верификации",
      benefit1: "Значок верификации в профиле",
      benefit2: "Повышенное доверие посетителей",
      benefit3: "Приоритет в результатах поиска",
      showBadge: "Показывать значок верификации",
      hideBadge: "Скрыть значок верификации",
      badgeUpdated: "Видимость значка обновлена",
    },
    es: {
      title: "Verificación",
      subtitle: "Verifícate y aumenta la confianza",
      status: "Estado de verificación",
      notVerified: "No verificado",
      pending: "En revisión",
      approved: "Verificado",
      rejected: "Rechazado",
      applyTitle: "Solicitar verificación",
      applyDesc: "Las cuentas verificadas obtienen una insignia y mayor visibilidad",
      requirements: "Requisitos",
      req1: "Información de perfil completa",
      req2: "Al menos una página publicada",
      req3: "Cuenta activa por más de 7 días",
      applyButton: "Solicitar verificación",
      applying: "Enviando...",
      applicationSent: "Solicitud enviada exitosamente",
      alreadyApplied: "Ya has enviado una solicitud",
      benefits: "Beneficios de la verificación",
      benefit1: "Insignia de verificación en el perfil",
      benefit2: "Mayor confianza de los visitantes",
      benefit3: "Prioridad en resultados de búsqueda",
      showBadge: "Mostrar insignia de verificación",
      hideBadge: "Ocultar insignia de verificación",
      badgeUpdated: "Visibilidad de insignia actualizada",
    },
  },

  // ==================== SUPPORT ====================
  support: {
    en: {
      title: "Support",
      subtitle: "How can we help you?",
      newTicket: "New Ticket",
      myTickets: "My Tickets",
      noTickets: "No tickets yet",
      noTicketsDesc: "Create a ticket if you need help",
      createTicket: "Create Ticket",
      subject: "Subject",
      subjectPlaceholder: "Brief description of the issue",
      message: "Message",
      messagePlaceholder: "Describe your issue in detail...",
      category: "Category",
      categoryGeneral: "General Question",
      categoryTechnical: "Technical Issue",
      categoryBilling: "Billing",
      categoryFeature: "Feature Request",
      categoryOther: "Other",
      priority: "Priority",
      priorityLow: "Low",
      priorityMedium: "Medium",
      priorityHigh: "High",
      submit: "Submit Ticket",
      submitting: "Submitting...",
      ticketCreated: "Ticket created successfully",
      ticketStatus: "Status",
      statusOpen: "Open",
      statusInProgress: "In Progress",
      statusResolved: "Resolved",
      statusClosed: "Closed",
      reply: "Reply",
      replyPlaceholder: "Type your reply...",
      sendReply: "Send Reply",
      staffReply: "Staff Reply",
      supportAgent: "Support Agent",
      yourMessage: "Your Message",
      lastUpdated: "Last updated",
      closeTicket: "Close Ticket",
      reopenTicket: "Reopen Ticket",
      newTicketNotification: "New support request",
      newTicketNotificationDesc: "Check the tickets section in the admin panel",
    },
    ru: {
      title: "Поддержка",
      subtitle: "Чем мы можем помочь?",
      newTicket: "Новый тикет",
      myTickets: "Мои тикеты",
      noTickets: "Тикетов пока нет",
      noTicketsDesc: "Создайте тикет, если вам нужна помощь",
      createTicket: "Создать тикет",
      subject: "Тема",
      subjectPlaceholder: "Краткое описание проблемы",
      message: "Сообщение",
      messagePlaceholder: "Опишите вашу проблему подробно...",
      category: "Категория",
      categoryGeneral: "Общий вопрос",
      categoryTechnical: "Техническая проблема",
      categoryBilling: "Оплата",
      categoryFeature: "Запрос функции",
      categoryOther: "Другое",
      priority: "Приоритет",
      priorityLow: "Низкий",
      priorityMedium: "Средний",
      priorityHigh: "Высокий",
      submit: "Отправить тикет",
      submitting: "Отправка...",
      ticketCreated: "Тикет успешно создан",
      ticketStatus: "Статус",
      statusOpen: "Открыт",
      statusInProgress: "В работе",
      statusResolved: "Решён",
      statusClosed: "Закрыт",
      reply: "Ответить",
      replyPlaceholder: "Введите ваш ответ...",
      sendReply: "Отправить ответ",
      staffReply: "Ответ поддержки",
      supportAgent: "Агент поддержки",
      yourMessage: "Ваше сообщение",
      lastUpdated: "Последнее обновление",
      closeTicket: "Закрыть тикет",
      reopenTicket: "Открыть заново",
      newTicketNotification: "Новое обращение в поддержку",
      newTicketNotificationDesc: "Проверьте раздел тикетов в админ-панели",
    },
    es: {
      title: "Soporte",
      subtitle: "¿Cómo podemos ayudarte?",
      newTicket: "Nuevo ticket",
      myTickets: "Mis tickets",
      noTickets: "Sin tickets aún",
      noTicketsDesc: "Crea un ticket si necesitas ayuda",
      createTicket: "Crear ticket",
      subject: "Asunto",
      subjectPlaceholder: "Breve descripción del problema",
      message: "Mensaje",
      messagePlaceholder: "Describe tu problema en detalle...",
      category: "Categoría",
      categoryGeneral: "Pregunta general",
      categoryTechnical: "Problema técnico",
      categoryBilling: "Facturación",
      categoryFeature: "Solicitud de función",
      categoryOther: "Otro",
      priority: "Prioridad",
      priorityLow: "Baja",
      priorityMedium: "Media",
      priorityHigh: "Alta",
      submit: "Enviar ticket",
      submitting: "Enviando...",
      ticketCreated: "Ticket creado exitosamente",
      ticketStatus: "Estado",
      statusOpen: "Abierto",
      statusInProgress: "En progreso",
      statusResolved: "Resuelto",
      statusClosed: "Cerrado",
      reply: "Responder",
      replyPlaceholder: "Escribe tu respuesta...",
      sendReply: "Enviar respuesta",
      staffReply: "Respuesta del equipo",
      supportAgent: "Agente de soporte",
      yourMessage: "Tu mensaje",
      lastUpdated: "Última actualización",
      closeTicket: "Cerrar ticket",
      reopenTicket: "Reabrir ticket",
      newTicketNotification: "Nueva solicitud de soporte",
      newTicketNotificationDesc: "Revisa la sección de tickets en el panel de administración",
    },
  },

  // ==================== FAQ ====================
  faq: {
    en: {
      title: "FAQ",
      subtitle: "Frequently Asked Questions",
      q1: "What is Mus.Link?",
      a1: "Mus.Link is a smart link service for musicians. Create one link that directs fans to your music on all streaming platforms.",
      q2: "Is it free?",
      a2: "Yes! The basic plan is completely free. We also offer a Pro plan with advanced features.",
      q3: "How do I create a smart link?",
      a3: "Sign up, click 'Create Page', paste a link from any streaming platform, and we'll automatically find your music on other platforms.",
      q4: "What platforms are supported?",
      a4: "We support all major platforms: Spotify, Apple Music, YouTube Music, Deezer, Tidal, SoundCloud, Amazon Music, and many more.",
      q5: "Can I use my own domain?",
      a5: "Yes! Pro users can connect custom domains to their smart link pages.",
      q6: "How does analytics work?",
      a6: "We track views and clicks on your smart link pages. Pro users get advanced analytics with geographic data and device statistics.",
      q7: "What is UPC code search?",
      a7: "You can paste a UPC barcode (10-14 digits) from your release, and we'll automatically find it on all platforms.",
      noAnswer: "Didn't find your answer?",
      contactUs: "Contact us",
    },
    ru: {
      title: "FAQ",
      subtitle: "Часто задаваемые вопросы",
      q1: "Что такое Mus.Link?",
      a1: "Mus.Link — это сервис смарт-ссылок для музыкантов. Создайте одну ссылку, которая направит фанатов к вашей музыке на всех стриминговых платформах.",
      q2: "Это бесплатно?",
      a2: "Да! Базовый план полностью бесплатен. Мы также предлагаем план Pro с расширенными функциями.",
      q3: "Как создать смарт-ссылку?",
      a3: "Зарегистрируйтесь, нажмите 'Создать страницу', вставьте ссылку с любой платформы, и мы автоматически найдём вашу музыку на других платформах.",
      q4: "Какие платформы поддерживаются?",
      a4: "Мы поддерживаем все основные платформы: Spotify, Apple Music, YouTube Music, Deezer, Tidal, SoundCloud, Amazon Music и многие другие.",
      q5: "Могу ли я использовать свой домен?",
      a5: "Да! Пользователи Pro могут подключить собственные домены к своим страницам.",
      q6: "Как работает аналитика?",
      a6: "Мы отслеживаем просмотры и клики на ваших страницах. Пользователи Pro получают расширенную аналитику с географией и статистикой устройств.",
      q7: "Что такое поиск по UPC коду?",
      a7: "Вы можете вставить UPC штрих-код (10-14 цифр) вашего релиза, и мы автоматически найдём его на всех платформах.",
      noAnswer: "Не нашли ответ?",
      contactUs: "Свяжитесь с нами",
    },
    es: {
      title: "FAQ",
      subtitle: "Preguntas frecuentes",
      q1: "¿Qué es Mus.Link?",
      a1: "Mus.Link es un servicio de enlaces inteligentes para músicos. Crea un enlace que dirija a tus fans a tu música en todas las plataformas de streaming.",
      q2: "¿Es gratis?",
      a2: "¡Sí! El plan básico es completamente gratis. También ofrecemos un plan Pro con funciones avanzadas.",
      q3: "¿Cómo creo un enlace inteligente?",
      a3: "Regístrate, haz clic en 'Crear página', pega un enlace de cualquier plataforma, y encontraremos automáticamente tu música en otras plataformas.",
      q4: "¿Qué plataformas son compatibles?",
      a4: "Soportamos todas las plataformas principales: Spotify, Apple Music, YouTube Music, Deezer, Tidal, SoundCloud, Amazon Music y muchas más.",
      q5: "¿Puedo usar mi propio dominio?",
      a5: "¡Sí! Los usuarios Pro pueden conectar dominios personalizados a sus páginas.",
      q6: "¿Cómo funciona la analítica?",
      a6: "Rastreamos vistas y clics en tus páginas. Los usuarios Pro obtienen analíticas avanzadas con datos geográficos y estadísticas de dispositivos.",
      q7: "¿Qué es la búsqueda por código UPC?",
      a7: "Puedes pegar un código de barras UPC (10-14 dígitos) de tu lanzamiento, y lo encontraremos automáticamente en todas las plataformas.",
      noAnswer: "¿No encontraste tu respuesta?",
      contactUs: "Contáctanos",
    },
  },

  // ==================== RANDOM COVER ====================
  randomCover: {
    en: {
      title: "Random Cover Generator",
      subtitle: "Generate unique cover art with AI",
      generate: "Generate",
      generating: "Generating (~30 sec)...",
      download: "Download",
      regenerate: "Regenerate",
      prompt: "Describe your cover",
      promptPlaceholder: "Abstract colorful music waves...",
      style: "Style",
      styleAbstract: "Abstract",
      styleMinimal: "Minimal",
      styleVintage: "Vintage",
      styleNeon: "Neon",
      styleDark: "Dark",
      styleColorful: "Colorful",
      size: "Size",
      history: "History",
      noHistory: "No generated covers yet",
      saveToPage: "Use for page",
      proFeature: "Pro Feature",
      upgradeForAI: "Upgrade to Pro to generate AI covers",
      generationFailed: "Generation failed. Please try again.",
      downloadStarted: "Download started",
      editor: "Editor",
      myProjects: "My Projects",
      tools: "Tools Panel",
      background: "Background",
      text: "Text",
      actions: "Actions",
      backgroundImage: "Background Image",
      uploadPhoto: "Upload Photo",
      replacePhoto: "Replace Photo",
      aiGeneration: "AI Generation (Stable Diffusion XL)",
      describeImage: "Describe the image in English...",
      proOnly: "Pro only",
      proOnlyFeature: "This feature is only available in Pro version",
      filter: "Filter",
      content: "Content",
      enterText: "Enter text",
      font: "Font",
      color: "Color",
      deleteText: "Delete Text",
      selectOrAddText: "Select text on canvas or add new",
      addText: "Add Text",
      randomDesign: "Random Design",
      reset: "Reset",
      saveHD: "Save (3000x3000)",
      tips: "Tips",
      tip1: "Changes apply instantly",
      tip2: "Elements snap to center and each other",
      tip3: "Project auto-saves",
      undo: "Undo (Ctrl+Z)",
      redo: "Redo (Ctrl+Y)",
      saveProject: "Save Project",
      noProjects: "No saved projects",
      noProjectsDesc: "Create your first cover in the editor and save the project",
      goToEditor: "Go to Editor",
      open: "Open",
      photo: "Photo",
      processingImage: "Processing image...",
      imageUploaded: "Image uploaded",
      imageLoadError: "Failed to load image",
      imageProcessError: "Failed to process image",
      projectNameRequired: "Enter a project name",
      projectUpdated: "Project updated",
      projectSaved: "Project saved",
      projectSaveError: "Failed to save project",
      projectNotFound: "Project not found",
      projectLoaded: "Project loaded",
      projectLoadError: "Failed to load project",
      deleteProjectConfirm: "Delete this project?",
      projectDeleted: "Project deleted",
      projectDeleteError: "Failed to delete project",
      newProjectCreated: "New project created",
      undone: "Undone",
      redone: "Redone",
      promptRequired: "Enter a prompt for generation",
      aiImageGenerated: "AI image generated",
      projectRecovered: "Project recovered",
      defaultText: "Your text",
      randomDesignApplied: "Random design applied",
      designReset: "Design reset",
      coverSaved: "Cover saved",
      coverSaveError: "Failed to save cover",
    },
    ru: {
      title: "Генератор обложек",
      subtitle: "Создавайте уникальные обложки с помощью ИИ",
      generate: "Сгенерировать",
      generating: "Генерация (~30 сек)...",
      download: "Скачать",
      regenerate: "Ещё раз",
      prompt: "Опишите обложку",
      promptPlaceholder: "Абстрактные цветные музыкальные волны...",
      style: "Стиль",
      styleAbstract: "Абстракция",
      styleMinimal: "Минимализм",
      styleVintage: "Винтаж",
      styleNeon: "Неон",
      styleDark: "Тёмный",
      styleColorful: "Цветной",
      size: "Размер",
      history: "История",
      noHistory: "Пока нет сгенерированных обложек",
      saveToPage: "Использовать для страницы",
      proFeature: "Pro функция",
      upgradeForAI: "Перейдите на Pro для генерации ИИ-обложек",
      generationFailed: "Ошибка генерации. Попробуйте снова.",
      downloadStarted: "Загрузка началась",
      editor: "Редактор",
      myProjects: "Мои проекты",
      tools: "Панель инструментов",
      background: "Фон",
      text: "Текст",
      actions: "Действия",
      backgroundImage: "Фоновое изображение",
      uploadPhoto: "Загрузить фото",
      replacePhoto: "Заменить фото",
      aiGeneration: "AI Генерация (Stable Diffusion XL)",
      describeImage: "Опишите изображение на английском...",
      proOnly: "Только для PRO",
      proOnlyFeature: "Эта функция доступна только в PRO-версии",
      filter: "Фильтр",
      content: "Содержание",
      enterText: "Введите текст",
      font: "Шрифт",
      color: "Цвет",
      deleteText: "Удалить текст",
      selectOrAddText: "Выберите текст на холсте или добавьте новый",
      addText: "Добавить текст",
      randomDesign: "Случайный дизайн",
      reset: "Сбросить",
      saveHD: "Сохранить (3000x3000)",
      tips: "Советы",
      tip1: "Изменения применяются мгновенно",
      tip2: "Элементы примагничиваются к центру и друг к другу",
      tip3: "Проект автоматически сохраняется",
      undo: "Отмена",
      redo: "Повтор",
      saveProject: "Сохранить проект",
      noProjects: "Нет сохранённых проектов",
      noProjectsDesc: "Создайте свою первую обложку в редакторе и сохраните проект",
      goToEditor: "Перейти в редактор",
      open: "Открыть",
      photo: "Фото",
      processingImage: "Обработка изображения...",
      imageUploaded: "Изображение загружено",
      imageLoadError: "Ошибка загрузки изображения",
      imageProcessError: "Ошибка обработки изображения",
      projectNameRequired: "Введите название проекта",
      projectUpdated: "Проект обновлён",
      projectSaved: "Проект сохранён",
      projectSaveError: "Ошибка сохранения проекта",
      projectNotFound: "Проект не найден",
      projectLoaded: "Проект загружен",
      projectLoadError: "Ошибка загрузки проекта",
      deleteProjectConfirm: "Удалить этот проект?",
      projectDeleted: "Проект удалён",
      projectDeleteError: "Ошибка удаления проекта",
      newProjectCreated: "Новый проект создан",
      undone: "Отменено",
      redone: "Повторено",
      promptRequired: "Введите промпт для генерации",
      aiImageGenerated: "AI изображение сгенерировано",
      projectRecovered: "Проект восстановлен",
      defaultText: "Ваш текст",
      randomDesignApplied: "Случайный дизайн применён",
      designReset: "Дизайн сброшен",
      coverSaved: "Обложка сохранена",
      coverSaveError: "Ошибка сохранения обложки",
    },
    es: {
      title: "Generador de portadas",
      subtitle: "Genera portadas únicas con IA",
      generate: "Generar",
      generating: "Generando (~30 seg)...",
      download: "Descargar",
      regenerate: "Regenerar",
      prompt: "Describe tu portada",
      promptPlaceholder: "Ondas musicales abstractas y coloridas...",
      style: "Estilo",
      styleAbstract: "Abstracto",
      styleMinimal: "Minimalista",
      styleVintage: "Vintage",
      styleNeon: "Neón",
      styleDark: "Oscuro",
      styleColorful: "Colorido",
      size: "Tamaño",
      history: "Historial",
      noHistory: "Sin portadas generadas aún",
      saveToPage: "Usar para página",
      proFeature: "Función Pro",
      upgradeForAI: "Mejora a Pro para generar portadas con IA",
      generationFailed: "Error de generación. Intenta de nuevo.",
      downloadStarted: "Descarga iniciada",
      editor: "Editor",
      myProjects: "Mis Proyectos",
      tools: "Panel de Herramientas",
      background: "Fondo",
      text: "Texto",
      actions: "Acciones",
      backgroundImage: "Imagen de Fondo",
      uploadPhoto: "Subir Foto",
      replacePhoto: "Reemplazar Foto",
      aiGeneration: "Generación IA (Stable Diffusion XL)",
      describeImage: "Describe la imagen en inglés...",
      proOnly: "Solo Pro",
      proOnlyFeature: "Esta función solo está disponible en la versión Pro",
      filter: "Filtro",
      content: "Contenido",
      enterText: "Ingresa texto",
      font: "Fuente",
      color: "Color",
      deleteText: "Eliminar Texto",
      selectOrAddText: "Selecciona texto en el lienzo o agrega uno nuevo",
      addText: "Agregar Texto",
      randomDesign: "Diseño Aleatorio",
      reset: "Reiniciar",
      saveHD: "Guardar (3000x3000)",
      tips: "Consejos",
      tip1: "Los cambios se aplican instantáneamente",
      tip2: "Los elementos se alinean al centro y entre sí",
      tip3: "El proyecto se guarda automáticamente",
      undo: "Deshacer",
      redo: "Rehacer",
      saveProject: "Guardar Proyecto",
      noProjects: "Sin proyectos guardados",
      noProjectsDesc: "Crea tu primera portada en el editor y guarda el proyecto",
      goToEditor: "Ir al Editor",
      open: "Abrir",
      photo: "Foto",
      processingImage: "Procesando imagen...",
      imageUploaded: "Imagen cargada",
      imageLoadError: "Error al cargar imagen",
      imageProcessError: "Error al procesar imagen",
      projectNameRequired: "Ingresa un nombre de proyecto",
      projectUpdated: "Proyecto actualizado",
      projectSaved: "Proyecto guardado",
      projectSaveError: "Error al guardar el proyecto",
      projectNotFound: "Proyecto no encontrado",
      projectLoaded: "Proyecto cargado",
      projectLoadError: "Error al cargar el proyecto",
      deleteProjectConfirm: "¿Eliminar este proyecto?",
      projectDeleted: "Proyecto eliminado",
      projectDeleteError: "Error al eliminar el proyecto",
      newProjectCreated: "Nuevo proyecto creado",
      undone: "Deshecho",
      redone: "Rehecho",
      promptRequired: "Ingresa un prompt para generar",
      aiImageGenerated: "Imagen generada con IA",
      projectRecovered: "Proyecto restaurado",
      defaultText: "Tu texto",
      randomDesignApplied: "Diseño aleatorio aplicado",
      designReset: "Diseño restablecido",
      coverSaved: "Portada guardada",
      coverSaveError: "Error al guardar la portada",
    },
  },

  // ==================== PRO FEATURE MODAL ====================
  proModal: {
    en: {
      title: "Coming Soon",
      description: "This feature is not available yet. Leave your email and we'll notify you when it's ready.",
      submit: "Notify Me",
      emailRequired: "Email is required",
      invalidEmail: "Please enter a valid email",
      waitCooldown: "Please wait {seconds} seconds before trying again",
      tooManyRequests: "Too many requests. Please try again later.",
      submitError: "Failed to submit. Please try again.",
      successTitle: "You're on the list!",
      successMessage: "We'll notify you when this feature becomes available.",
      successToast: "Successfully added to waitlist!",
      alreadySubmitted: "We've already received your email. You'll be notified when the feature is available.",
      limitReached: "Limit reached. Upgrade to PRO to unlock more.",
    },
    ru: {
      title: "Скоро будет",
      description: "Функция пока недоступна. Оставьте свою почту, чтобы мы могли вас уведомить о доступности функционала.",
      submit: "Уведомить меня",
      emailRequired: "Введите email",
      invalidEmail: "Введите корректный email",
      waitCooldown: "Подождите {seconds} секунд перед повторной попыткой",
      tooManyRequests: "Слишком много запросов. Попробуйте позже.",
      submitError: "Не удалось отправить. Попробуйте снова.",
      successTitle: "Вы в списке!",
      successMessage: "Мы уведомим вас, когда функция станет доступна.",
      successToast: "Вы успешно добавлены в список ожидания!",
      alreadySubmitted: "Мы уже получили вашу почту, ожидайте уведомления о доступности функционала.",
      limitReached: "Лимит достигнут, перейдите на PRO-подписку.",
    },
    es: {
      title: "Próximamente",
      description: "Esta función aún no está disponible. Deja tu correo y te avisaremos cuando esté lista.",
      submit: "Notificarme",
      emailRequired: "El correo es requerido",
      invalidEmail: "Ingresa un correo válido",
      waitCooldown: "Espera {seconds} segundos antes de intentar de nuevo",
      tooManyRequests: "Demasiadas solicitudes. Intenta más tarde.",
      submitError: "Error al enviar. Intenta de nuevo.",
      successTitle: "¡Estás en la lista!",
      successMessage: "Te notificaremos cuando esta función esté disponible.",
      successToast: "¡Añadido a la lista de espera!",
      alreadySubmitted: "Ya hemos recibido tu correo. Te notificaremos cuando la función esté disponible.",
      limitReached: "Límite alcanzado. Actualiza a PRO para desbloquear más.",
    },
  },

  // ==================== NEW LANDING ====================
  newLanding: {
    en: {
      // Hero
      heroTitle: "Smart Links for Musicians",
      heroSubtitle: "One link for all platforms. Share your music everywhere with a single, beautiful page.",
      ctaCreate: "Create Smart Link",
      ctaDemo: "See Demo",
      // Features
      featuresTitle: "Everything You Need",
      feature1Title: "All Platforms",
      feature1Desc: "Spotify, Apple Music, YouTube, and 20+ more streaming services in one link",
      feature2Title: "One Link",
      feature2Desc: "Share a single URL that works everywhere — social media, bio, ads",
      feature3Title: "Analytics",
      feature3Tag: "PRO",
      feature3Desc: "Track clicks, views, and geographic data in real-time",
      feature4Title: "Custom Design",
      feature4Tag: "PRO",
      feature4Desc: "Personalize colors, fonts, and layout to match your brand",
      feature5Title: "QR Codes",
      feature5Desc: "Generate QR codes for posters, flyers, and physical promo",
      feature6Title: "Fast & Free",
      feature6Desc: "Create your page in under 60 seconds. Basic features are free forever",
      chartEyebrow: "Chart",
      chartTitle: "Discover what is moving",
      chartDesc: "A public chart of popular Mus.Link releases, ranked by listener activity with a small boost for verified PRO artists.",
      chartButton: "Open Chart",
      // How it works
      howTitle: "How It Works",
      step1Title: "Paste Link or UPC",
      step1Desc: "Enter your song/album link from any platform or UPC code",
      step2Title: "Auto-fill Platforms",
      step2Desc: "We automatically find links on all major streaming services",
      step3Title: "Share Everywhere",
      step3Desc: "Get your smart link and share it across all your channels",
      // Preview
      previewTitle: "See It In Action",
      previewSubtitle: "Clean, fast, mobile-optimized pages that convert listeners",
      // FAQ
      faqTitle: "Frequently Asked Questions",
      faq1Q: "Is MusLink free?",
      faq1A: "Yes! Basic features are free forever. PRO unlocks analytics, custom domains, and more.",
      faq2Q: "How does auto-fill work?",
      faq2A: "Paste any streaming link or UPC code.",
      faq3Q: "Can I use my own domain?",
      faq3A: "Yes, PRO users can connect custom domains and subdomains.",
      faq4Q: "What analytics do I get?",
      faq4A: "PRO analytics include clicks, views, geographic data, referral sources, and daily trends.",
      // Footer
      footerTagline: "Smart links for musicians",
      footerRights: "All Rights Reserved.",
    },
    ru: {
      // Hero
      heroTitle: "Умные ссылки для музыкантов",
      heroSubtitle: "Одна ссылка для всех платформ. Делитесь музыкой везде с помощью одной красивой страницы.",
      ctaCreate: "Создать ссылку",
      ctaDemo: "Смотреть демо",
      // Features
      featuresTitle: "Всё что нужно",
      feature1Title: "Все платформы",
      feature1Desc: "Spotify, Apple Music, YouTube и 20+ стриминговых сервисов в одной ссылке",
      feature2Title: "Одна ссылка",
      feature2Desc: "Одна ссылка работает везде — соцсети, био, реклама",
      feature3Title: "Аналитика",
      feature3Tag: "PRO",
      feature3Desc: "Отслеживайте клики, просмотры и географию в реальном времени",
      feature4Title: "Свой дизайн",
      feature4Tag: "PRO",
      feature4Desc: "Настройте цвета, шрифты и макет под свой бренд",
      feature5Title: "QR-коды",
      feature5Desc: "Создавайте QR-коды для постеров, флаеров и физического промо",
      feature6Title: "Быстро и бесплатно",
      feature6Desc: "Создайте страницу за 60 секунд. Базовые функции бесплатны навсегда",
      chartEyebrow: "Чарт",
      chartTitle: "Откройте релизы, которые набирают ход",
      chartDesc: "Публичный чарт популярных релизов Mus.Link с рейтингом по активности слушателей и небольшим приоритетом для верифицированных PRO-артистов.",
      chartButton: "Открыть чарт",
      // How it works
      howTitle: "Как это работает",
      step1Title: "Вставьте ссылку или UPC",
      step1Desc: "Введите ссылку на трек/альбом с любой платформы или UPC-код",
      step2Title: "Автозаполнение платформ",
      step2Desc: "Мы автоматически найдём ссылки на всех основных сервисах",
      step3Title: "Делитесь везде",
      step3Desc: "Получите свою смарт-ссылку и делитесь ею во всех каналах",
      // Preview
      previewTitle: "Посмотрите в действии",
      previewSubtitle: "Чистые, быстрые, мобильные страницы, которые конвертируют слушателей",
      // FAQ
      faqTitle: "Частые вопросы",
      faq1Q: "MusLink бесплатен?",
      faq1A: "Да! Базовые функции бесплатны навсегда. PRO открывает аналитику, свои домены и многое другое.",
      faq2Q: "Как работает автозаполнение?",
      faq2A: "Вставьте любую стриминговую ссылку или UPC-код.",
      faq3Q: "Могу ли я использовать свой домен?",
      faq3A: "Да, PRO-пользователи могут подключить свои домены и поддомены.",
      faq4Q: "Какую аналитику я получу?",
      faq4A: "PRO-аналитика включает клики, просмотры, географию, источники переходов и дневные тренды.",
      // Footer
      footerTagline: "Умные ссылки для музыкантов",
      footerRights: "Все права защищены.",
    },
    es: {
      // Hero
      heroTitle: "Enlaces inteligentes para músicos",
      heroSubtitle: "Un enlace para todas las plataformas. Comparte tu música en todas partes con una sola página hermosa.",
      ctaCreate: "Crear enlace",
      ctaDemo: "Ver demo",
      // Features
      featuresTitle: "Todo lo que necesitas",
      feature1Title: "Todas las plataformas",
      feature1Desc: "Spotify, Apple Music, YouTube y más de 20 servicios de streaming en un enlace",
      feature2Title: "Un solo enlace",
      feature2Desc: "Un enlace que funciona en todas partes — redes sociales, bio, anuncios",
      feature3Title: "Analíticas",
      feature3Tag: "PRO",
      feature3Desc: "Rastrea clics, vistas y datos geográficos en tiempo real",
      feature4Title: "Diseño personalizado",
      feature4Tag: "PRO",
      feature4Desc: "Personaliza colores, fuentes y diseño para tu marca",
      feature5Title: "Códigos QR",
      feature5Desc: "Genera códigos QR para posters, flyers y promoción física",
      feature6Title: "Rápido y gratis",
      feature6Desc: "Crea tu página en menos de 60 segundos. Las funciones básicas son gratis para siempre",
      chartEyebrow: "Chart",
      chartTitle: "Descubre lo que está creciendo",
      chartDesc: "Un chart público de lanzamientos populares en Mus.Link, clasificado por actividad de oyentes con un pequeño impulso para artistas PRO verificados.",
      chartButton: "Abrir chart",
      // How it works
      howTitle: "Cómo funciona",
      step1Title: "Pega enlace o UPC",
      step1Desc: "Ingresa el enlace de tu canción/álbum de cualquier plataforma o código UPC",
      step2Title: "Auto-completado",
      step2Desc: "Encontramos automáticamente enlaces en todos los servicios principales",
      step3Title: "Comparte en todas partes",
      step3Desc: "Obtén tu enlace inteligente y compártelo en todos tus canales",
      // Preview
      previewTitle: "Míralo en acción",
      previewSubtitle: "Páginas limpias, rápidas y optimizadas para móvil que convierten oyentes",
      // FAQ
      faqTitle: "Preguntas frecuentes",
      faq1Q: "MusLink es gratis?",
      faq1A: "¡Sí! Las funciones básicas son gratis para siempre. PRO desbloquea analíticas, dominios personalizados y más.",
      faq2Q: "¿Cómo funciona el auto-completado?",
      faq2A: "Pega cualquier enlace de streaming o código UPC.",
      faq3Q: "¿Puedo usar mi propio dominio?",
      faq3A: "Sí, los usuarios PRO pueden conectar dominios y subdominios personalizados.",
      faq4Q: "¿Qué analíticas obtengo?",
      faq4A: "Las analíticas PRO incluyen clics, vistas, datos geográficos, fuentes de referencia y tendencias diarias.",
      // Footer
      footerTagline: "Enlaces inteligentes para músicos",
      footerRights: "Todos los derechos reservados.",
    },
  },

  // ==================== FORGOT PASSWORD ====================
  forgotPassword: {
    en: {
      backToLogin: "Back to login",
      title: "Reset password",
      description: "Enter your email address to receive a password reset link.",
      submit: "Send reset link",
      sending: "Sending...",
      successToast: "Password reset email sent. Please check your inbox.",
      checkEmail: "Check your email",
      sentTo: "We sent a password reset link to",
      checkSpam: "Didn't receive the email? Check your spam folder.",
      sendAgain: "Send again",
      rememberPassword: "Remember your password?",
      rightTitle: "Password recovery",
      rightDesc: "Enter your email to receive secure recovery instructions.",
    },
    ru: {
      backToLogin: "Вернуться к входу",
      title: "Сброс пароля",
      description: "Введите email, чтобы получить ссылку для сброса пароля.",
      submit: "Отправить ссылку",
      sending: "Отправка...",
      successToast: "Письмо для сброса пароля отправлено. Проверьте почту.",
      checkEmail: "Проверьте почту",
      sentTo: "Мы отправили ссылку для сброса пароля на",
      checkSpam: "Если письмо не пришло, проверьте папку спама.",
      sendAgain: "Отправить снова",
      rememberPassword: "Помните пароль?",
      rightTitle: "Восстановление доступа",
      rightDesc: "Введите email, чтобы получить инструкции по восстановлению.",
    },
    es: {
      backToLogin: "Volver al inicio de sesión",
      title: "Restablecer contraseña",
      description: "Ingresa tu correo electrónico para recibir un enlace de restablecimiento.",
      submit: "Enviar enlace",
      sending: "Enviando...",
      successToast: "Correo de restablecimiento enviado. Revisa tu bandeja de entrada.",
      checkEmail: "Revisa tu correo",
      sentTo: "Enviamos un enlace de restablecimiento a",
      checkSpam: "¿No recibiste el correo? Revisa tu carpeta de spam.",
      sendAgain: "Enviar de nuevo",
      rememberPassword: "¿Recuerdas tu contraseña?",
      rightTitle: "Recuperación de acceso",
      rightDesc: "Ingresa tu correo para recibir instrucciones de recuperación.",
    },
  },

  // ==================== PLATFORMS ====================
  platforms: {
    en: {
      spotify: "Spotify",
      appleMusic: "Apple Music",
      itunes: "iTunes",
      youtube: "YouTube",
      youtubeMusic: "YouTube Music",
      yandex: "Yandex Music",
      vk: "VK Music",
      tiktok: "TikTok",
      deezer: "Deezer",
      tidal: "Tidal",
      amazonMusic: "Amazon Music",
      amazonStore: "Amazon Store",
      soundcloud: "SoundCloud",
      pandora: "Pandora",
      napster: "Napster",
      audiomack: "Audiomack",
      audius: "Audius",
      anghami: "Anghami",
      boomplay: "Boomplay",
      bandcamp: "Bandcamp",
      zvuk: "Zvuk",
      mts: "Kion Music",
      custom: "Custom Link",
    },
    ru: {
      spotify: "Spotify",
      appleMusic: "Apple Music",
      itunes: "iTunes",
      youtube: "YouTube",
      youtubeMusic: "YouTube Music",
      yandex: "Яндекс Музыка",
      vk: "VK Музыка",
      tiktok: "TikTok",
      deezer: "Deezer",
      tidal: "Tidal",
      amazonMusic: "Amazon Music",
      amazonStore: "Amazon Store",
      soundcloud: "SoundCloud",
      pandora: "Pandora",
      napster: "Napster",
      audiomack: "Audiomack",
      audius: "Audius",
      anghami: "Anghami",
      boomplay: "Boomplay",
      bandcamp: "Bandcamp",
      zvuk: "Звук",
      mts: "Кион Музыка",
      custom: "Другая ссылка",
    },
    es: {
      spotify: "Spotify",
      appleMusic: "Apple Music",
      itunes: "iTunes",
      youtube: "YouTube",
      youtubeMusic: "YouTube Music",
      yandex: "Yandex Music",
      vk: "VK Music",
      tiktok: "TikTok",
      deezer: "Deezer",
      tidal: "Tidal",
      amazonMusic: "Amazon Music",
      amazonStore: "Amazon Store",
      soundcloud: "SoundCloud",
      pandora: "Pandora",
      napster: "Napster",
      audiomack: "Audiomack",
      audius: "Audius",
      anghami: "Anghami",
      boomplay: "Boomplay",
      bandcamp: "Bandcamp",
      zvuk: "Zvuk",
      mts: "Kion Music",
      custom: "Enlace Personalizado",
    },
  },
};

// Helper function to get translation
export const getTranslation = (section, key, language = 'en') => {
  const sectionData = translations[section];
  if (!sectionData) return key;
  
  const langData = sectionData[language] || sectionData['en'];
  if (!langData) return key;
  
  return langData[key] !== undefined ? langData[key] : (sectionData['en']?.[key] || key);
};

// Get all translations for a section
export const getSectionTranslations = (section, language = 'en') => {
  const sectionData = translations[section];
  if (!sectionData) return {};
  
  return sectionData[language] || sectionData['en'] || {};
};
